import { gql } from '@apollo/client';
import { client } from './graphClients';

/*
売上情報を取得

■リクエストパラメータ
input SalesByStoreInput {
  region: [
    { regionId: Int }   対象地区ID（複数指定可）※当面は未使用なので空の配列を指定してください。
  ]
  sv: [
    { svId: Int }       対象SV:ID（複数指定可）※当面は未使用なので空の配列を指定してください。
  ]
  operationMethod: [
    { operationMethodId: Int }  運営方式ID（複数指定可）※当面は未使用なので空の配列を指定してください。
  ]
  shop: [
    { shopId: Int }     店舗ID（複数指定可）
  ]
  dateType: Int       期間指定方法（1:日、2:月、3:年）
  fromDate: String     対象期間（開始）（YYYY-MM-DD）
  toDate: String     対象期間（終了）（YYYY-MM-DD）
}

■レスポンス
total {
  salesTotal  総売上（税込）
  sales       純売上（税抜）
  cost        原価（原価率）
  gross       粗利益（粗利率）
  pairs       組数
  visitor     客数
  customerUnitPrice   客単価
}
byDate {
  date        日付
  salesTotal  総売上（税込）
  sales       純売上（税抜）
  cost        原価（原価率）
  gross       粗利益（粗利率）
  pairs       組数
  visitor     客数
  customerUnitPrice   客単価
}
byTimeZone {
  timezone    時間
  salesTotal  総売上（税込）
  sales       純売上（税抜）
  cost        原価（原価率）
  gross       粗利益（粗利率）
  pairs       組数
  visitor     客数
  customerUnitPrice   客単価
}
*/
export const getSalesByStore = async (variables) => {
  console.log('variables', variables)
  const query = gql`query getSalesByStore($input: SalesByStoreInput) {
    getSalesByStore(input: $input) {
      total {
        salesTotal
        sales
        cost
        gross
        pairs
        visitor
        customerUnitPrice
      }
      byDate {
        date
        salesTotal
        sales
        cost
        gross
        pairs
        visitor
        customerUnitPrice
      }
      byTimeZone {
        timezone
        salesTotal
        sales
        cost
        gross
        pairs
        visitor
        customerUnitPrice
      }
    }
  }
  `;
  const res = await client.query({ query, variables });
  // console.log('res', res)
  return res;
};

/*
売上情報詳細を取得

■リクエストパラメータ
shop_id　店舗ID
date　対象日付（YYYY - MM - DD）

■レスポンス
id
date
subtotal          総売上【A】
subtotalDiscount  値引き額【B】
returnTotal       返品額【C】
pointDiscount     ポイント利用額【D】
couponDiscount    クーポン利用額【E】
taxExcludeTotal   外税受領額【F】
salesTotal        総売上(税込)【G】(A-B-C-D-E+F)
sales             純売上(税抜)【H】
taxInclude        内税【I】
taxExclude        外税【J】
taxTotal          消費税合計【K】(I+J)
nonTaxSalesTotal  非課税対象額【L】
cost              原価【M】
gross             粗利益【N】(G-M)
pairs             組数【O】
visitor           客数【P】
amount            点数【Q】
returnAmount      返品点数【R】
customerUnitPrice 客単価【S】(G/P)
composition {　　// 売上構成
  eatInSalesTotal     イートイン
  takeoutSalesTotal   テイクアウト
  deliverySalesTotal  デリバリー
}
salesType {      // 売上種別
  cashTotal       現金
  terminal {     // JET-S CATS300 (Array)
    paymentMethodName   支払い方法名
    paymentTotal        売上金額
  }
  delivery {     // デリバリー (Array)
    deliveryName  デリバリー名
    deliveryTotal 売上金額
  }
}
byTimeZone {     // 時間帯別
  timezone    時間
  salesTotal  総売上（税込）
  sales       純売上（税抜）
  cost        原価（原価率）
  gross       粗利益（粗利率）
  pairs       組数
  visitor     客数
  customerUnitPrice   客単価
}
*/
export const getSalesByStoreDetail = `query getSalesByStoreDetail( $shop_id: Int, $date: String ) {
  getSalesByStoreDetail(shop_id: $shop_id, date: $date) {
    id
    date
    subtotal
    subtotalDiscount
    returnTotal
    pointDiscount
    couponDiscount
    taxExcludeTotal
    salesTotal
    sales
    taxInclude
    taxExclude
    taxTotal
    nonTaxSalesTotal
    cost
    gross
    pairs
    visitor
    amount
    returnAmount
    customerUnitPrice
    composition {
      eatInSalesTotal
      takeoutSalesTotal
      deliverySalesTotal
    }
    salesType {
      cashTotal
      terminal {
        paymentMethodName
        paymentTotal
      }
      delivery {
        deliveryName
        deliveryTotal
      }
    }
    byTimeZone {
      timezone
      salesTotal
      sales
      cost
      gross
      pairs
      visitor
      customerUnitPrice
    }
  }
}
`;

/*
過去の現金残高を読み込み

■リクエストパラメータ
input CashBalanceInput {
  shop_id　店舗ID
  cashDrawerId レジ端末ID
  date　対象日付（YYYY-MM-DD）
}

■レスポンス
id
date　日時
carryOver  繰越準備金
cashSales  現金売上
calculateBalance　計算現金残高
realBalance　実現金残高 
depositCash　預り金
charge  釣銭
difference　現金過不足
tenThousandYen  1万円札
fiveThousandYen  5千円札
twoThousandYen  2千円札
oneThousandYen  千円札
fiveHundredYen  500円玉
oneHundredYen  100円玉
fiftyYen  50円玉
tenYen  10円玉
fiveYen  5円玉
oneYen  1円玉
*/
export const getCashBalanceAtDate = `query getCashBalanceAtDate( $input: CashBalanceInput ) {
  getCashBalanceAtDate(input: $input) {
    id
    date
    carryOver
    cashSales
    calculateBalance
    realBalance
    depositCash
    charge
    difference
    tenThousandYen
    fiveThousandYen
    twoThousandYen
    oneThousandYen
    fiveHundredYen
    oneHundredYen
    fiftyYen
    tenYen
    fiveYen
    oneYen
  }
}
`;


/*
登録済みキャッシュドロワ一覧を取得

■リクエストパラメータ
shop_id　店舗ID

■レスポンス
shop_id　店舗ID
cashDrawerId　レジ端末ID
cashDrawerName  レジ端末名
*/
export const getCashDrawerList = `query getCashDrawerList( $shop_id: Int ) {
  getCashDrawerList(shop_id: $shop_id) {
    shop_id
    cashDrawerId
    cashDrawerName
  }
}
`;
// export const getCashDrawerList = async (variables) => {
//   const query = gql`query getCashDrawerList( $shop_id: Int ) {
//     getCashDrawerList(shop_id: $shop_id) {
//       shop_id
//       cashDrawerId
//       cashDrawerName
//     }
//   }
//   `;
//   const res = await client.query({ query, variables });

//   return res;
// };


/*
店舗一覧を取得

■リクエストパラメータ
なし

■レスポンス
id
site_type   店舗形態
name        店舗名称
brandId     ブランドID
brandName   ブランド名称
*/
export const getShopList = `query getShopList {
    getShopList {
        id
        site_type
        name
        brandId
        brandName
    }
}
`;


// HOME : 売上概要データを取得
/*
■リクエストパラメータ
shop_ids  店舗ID(配列)
fromDate　検索対象開始日（YYYY-MM-DD）
toDate　　検索対象終了日（YYYY-MM-DD）

■レスポンスパラメータ
graph {　グラフ描画用データ
  date      日付
  net_sales 純売上
  gross     粗利
}
total_sales　総売上
total_net_sales　純売上
total_cost　　　　原価
total_cost_ratio　原価率
total_gross　　　　粗利
total_gross_ratio　粗利率
// 売上種別
cash_sales　　　現金
credit_sales	クレジットカード
emoney_sales　　電子マネー
qr_sales　　　　QRコード
other_sales　　　その他
// キャッシュレス比率
cash_ratio　　キャッシュレス
cashless_ratio　現金
*/
export const getSalesOverview = `query getSalesOverview($shop_ids: [Int], $fromDate: String, $toDate: String, $developerId: Int) {
  getSalesOverview( shop_ids: $shop_ids, fromDate: $fromDate, toDate: $toDate, developerId: $developerId ) {
    cash_ratio
    cash_sales
    cashless_ratio
    credit_sales
    emoney_sales
    other_sales
    qr_sales
    total_cost
    total_cost_ratio
    total_gross
    total_gross_ratio
    total_net_sales
    total_sales
    graph {
      date
      net_sales
      gross
    }
  }
}
`;


// 期間売上 : 期間売上概要データを取得
/*
■リクエストパラメータ
shop_ids  店舗ID(配列)
fromDate　検索対象開始日（YYYY-MM-DD）
toDate　　検索対象終了日（YYYY-MM-DD）

■レスポンスパラメータ
graph {　グラフ描画用データ
  date      日付
  net_sales 純売上
  gross     粗利
}
total_sales　総売上
total_net_sales　純売上
total_cost　　　　原価
total_cost_ratio　原価率
total_gross　　　　粗利
total_gross_ratio　粗利率
pairs     組数
visitor　　客数
customerUnitPrice　　客単価
daily {
  date
  total_sales　総売上
  total_net_sales　純売上
  total_cost　　　　原価
  total_cost_ratio　原価率
  total_gross　　　　粗利
  total_gross_ratio   粗利率
  pairs       組数
  visitor　　　客数
  customerUnitPrice　　客単価
}
*/
export const getPeriodSales = `query getPeriodSales($shop_ids: [Int], $fromDate: String, $toDate: String, $developerId: Int) {
  getPeriodSales( shop_ids: $shop_ids, fromDate: $fromDate, toDate: $toDate, developerId: $developerId ) {
    total_sales
    total_net_sales
    total_cost
    total_cost_ratio
    total_gross
    total_gross_ratio
    pairs
    visitor
    customerUnitPrice
    daily {
      date
      total_sales
      total_net_sales
      total_cost_ratio
      total_gross
      total_gross_ratio
      total_cost
      pairs
      visitor
      customerUnitPrice
    }
    graph {
      date
      net_sales
      gross
    }
  }
}
`;


// 期間売上 : 期間売上詳細を取得
/*
■リクエストパラメータ
shop_ids  店舗ID(配列)
date　検索対象日（YYYY-MM-DD）

■レスポンスパラメータ
sales     総売上(税込)
subtotalDiscountPrice    値引額
subtotalDiscountRate    割引額
returnTotal   返品額
cancelTotal   取消額
taxInclude    内税額
taxExclude    外税額
taxTotal      消費税合計
nonTaxSalesTotal  非課税対象額
net_sales     純売上(税抜)
cost          原価
gross         粗利益
salesTotal8    消費税対象額 (8%)
salesTotal10  消費税対象額 (10%)【
pairs   組数
guestNumbers  客数
amount    点数
returnAmount  返品点数
cancelAmount  取消点数
customerUnitPrice   客単価

// 売上構成
depositEatIn  イートイン
depositTakeout  テイクアウト
delivery    デリバリ

// 売上種別
depositCash   現金
depositOther  その他
depositCredit   クレジットカード
depositEMoney   電子マネー
depositQRcode   QRコード
deliveryUber    Uber Eats
deliveryDiDi    DiDi Food
deliveryDemaekan  出前館
deliveryFoodpanda   Foodpanda
deliveryOther  その他
*/
export const getPeriodSalesDetail = `query getPeriodSalesDetail($shop_ids: [Int], $date: String, $developerId: Int) {
  getPeriodSalesDetail( shop_ids: $shop_ids, date: $date, developerId: $developerId ) {
    sales
    subtotalDiscountPrice
    subtotalDiscountRate
    returnTotal
    cancelTotal
    taxInclude
    taxExclude
    taxTotal
    nonTaxSalesTotal
    net_sales
    cost
    gross
    salesTotal8
    salesTotal10
    pairs
    guestNumbers
    amount
    returnAmount
    cancelAmount
    customerUnitPrice
    depositEatIn
    depositTakeout
    delivery
    depositCash
    depositOther
    depositCredit
    depositEMoney
    depositQRcode
    deliveryUber
    deliveryDiDi
    deliveryDemaekan
    deliveryFoodpanda
    deliveryOther
  }
}
`;


// カテゴリ別売上 : カテゴリ別売上を取得
/*
■リクエストパラメータ
shop_ids  店舗ID(配列)
fromDate　検索対象開始日（YYYY-MM-DD）
toDate　　検索対象終了日（YYYY-MM-DD）

■レスポンスパラメータ
// イートイン
eatin {
  categoryName  カテゴリ名
  sales       総売上(税込)
  net_sales     純売上(税抜)
  quantity      販売数
  compositionRatio  構成比
}
// テイクアウト
takeout {
  categoryName  カテゴリ名
  sales       総売上(税込)
  net_sales     純売上(税抜)
  quantity      販売数
  compositionRatio  構成比
}
// デリバリー
delivery {
  categoryName  カテゴリ名
  sales       総売上(税込)
  net_sales     純売上(税抜)
  quantity      販売数
  compositionRatio  構成比
}

*/
export const getSalesByCategory = `query getSalesByCategory($shop_ids: [Int], $fromDate: String, $toDate: String, $developerId: Int) {
  getSalesByCategory( shop_ids: $shop_ids, fromDate: $fromDate, toDate: $toDate, developerId: $developerId ) {
    eatin {
      categoryName
      sales
      net_sales
      quantity
      compositionRatio
    }
    takeout {
      categoryName
      sales
      net_sales
      quantity
      compositionRatio
    }
    delivery {
      categoryName
      sales
      net_sales
      quantity
      compositionRatio
    }
  }
}
`;


// 商品別売上 : 商品別売上を取得
/*
■リクエストパラメータ
shop_ids  店舗ID(配列)
fromDate　検索対象開始日（YYYY-MM-DD）
toDate　　検索対象終了日（YYYY-MM-DD）

■レスポンスパラメータ
// イートイン
eatin {
  productName  商品名
  sales       総売上(税込)
  net_sales     純売上(税抜)
  quantity      販売数
  order_rate  オーダー率
  compositionRatio  構成比
}
// テイクアウト
takeout {
  productName  商品名
  sales       総売上(税込)
  net_sales     純売上(税抜)
  quantity      販売数
  order_rate  オーダー率
  compositionRatio  構成比
}
// デリバリー
delivery {
  productName  商品名
  sales       総売上(税込)
  net_sales     純売上(税抜)
  quantity      販売数
  order_rate  オーダー率
  compositionRatio  構成比
}

*/
export const getSalesByProduct = `query getSalesByProduct($shop_ids: [Int], $fromDate: String, $toDate: String, $developerId: Int) {
  getSalesByProduct( shop_ids: $shop_ids, fromDate: $fromDate, toDate: $toDate, developerId: $developerId ) {
    eatin {
      productName
      sales
      net_sales
      quantity
      order_rate
      compositionRatio
    }
    takeout {
      productName
      sales
      net_sales
      quantity
      order_rate
      compositionRatio
    }
    delivery {
      productName
      sales
      net_sales
      quantity
      order_rate
      compositionRatio
    }
    option {
      productName
      sales
      net_sales
      quantity
      order_rate
      compositionRatio
    }
  }
}
`;



// 時間帯売上 : 時間帯売上を取得
/*
■リクエストパラメータ
shop_ids  店舗ID(配列)
fromDate　検索対象開始日（YYYY-MM-DD）
toDate　　検索対象終了日（YYYY-MM-DD）

■レスポンスパラメータ
graph {
  hour      時間
  net_sales　純売上(税抜)
}
timezone {
  type
  timezoneLabel
  sales       総売上(税込)
  net_sales     純売上(税抜)
  composition_ratio  構成比
  guestNumbers    客数
  pairs           組数
  customerUnitPrice   客単価
}

*/
export const getSalesByTimezone = `query getSalesByTimezone($shop_ids: [Int], $fromDate: String, $toDate: String, $developerId: Int) {
  getSalesByTimezone( shop_ids: $shop_ids, fromDate: $fromDate, toDate: $toDate, developerId: $developerId ) {
    graph {
      hour
      net_sales
    }
    timezone {
      type
      timezoneLabel
      sales
      net_sales
      composition_ratio
      guestNumbers
      pairs
      customerUnitPrice
    }
  }
}
`;


// 取引履歴（電子ジャーナル） : 取引履歴一覧を取得
/*
■リクエストパラメータ
shop_ids  店舗ID(配列)
fromDate　検索対象開始日（YYYY-MM-DD）
toDate　　検索対象終了日（YYYY-MM-DD）
limit     1回の取得件数
offset    ページネーション

■レスポンスパラメータ
total   総件数
data {
  id
  date		取引日時
  mobile_order_id		注文番号
  subtotal		小計
  subtotalDiscountPrice		値引
  subtotalDiscountRate		割引
  total		合計支払額
  shopName		店舗名
  staffName		会計担当
}
*/
export const getJournalList = `query getJournalList($shop_ids: [Int], $fromDate: String, $toDate: String, $limit: Int, $offset: Int) {
  getJournalList( shop_ids: $shop_ids, fromDate: $fromDate, toDate: $toDate, limit: $limit, offset: $offset ) {
    total
    data {
      id
      date
      mobile_order_id
      subtotal
      subtotalDiscountPrice
      subtotalDiscountRate
      total
      method
      shopName
      staffName
    }
  }
}
`;


// 取引履歴（電子ジャーナル） : 取引履歴（電子ジャーナル）を取得
/*
■リクエストパラメータ
id  

■レスポンスパラメータ
date		取引日時
receiptId		レシート番号
acknowledgementId		領収書番号
shopName		店舗名
address		住所
tel		電話番号
mobile_order_id		注文番号
items: 		注文商品
subtotal		小計
subtotalDiscountPrice		値引
subtotalDiscountRate		割引
total		合計支払額
total8		8%対象
total10		10%対象
taxInclude		内税
taxInclude8		内税(8%)
taxInclude10		内税(10%)
depositCash		預り金　現金
depositCredit		　　　　クレジット
depositEMoney		　　　　電子マネー
depositQRcode		　　　　QRコード
depositOther		　　　　その他
charge		お釣り
payment_type		支払区分
order_type		注文区分
returnItems		取消品目
returnTotal		取消金額
cancelItems		返品
cancelTotal		返品金額
staff		会計担当

*/
export const getJournal = `query getJournal($id: Int) {
  getJournal( id: $id ) {
    date
    receiptId
    acknowledgementId
    shopName
    address
    tel
    mobile_order_id
    items {
      productName
      quantity
      salesPrice
    }
    subtotal
    subtotalDiscountPrice
    subtotalDiscountRate
    total
    total8
    total10
    taxInclude
    taxInclude8
    taxInclude10
    depositCash
    depositCredit
    depositEMoney
    depositQRcode
    depositOther
    charge
    payment_type
    order_type
    returnItems
    returnTotal
    cancelItems
    cancelTotal
    staff
  }
}
`;


// 日次締め一覧 : 日次締め一覧を取得
/*
■リクエストパラメータ
shop_ids  店舗ID
date　検索対象日（YYYY-MM-DD）

■レスポンスパラメータ
id
shopName  店舗名／レジ名
sumDateTime 締め時間
sales       総売上(税込)
net_sales     純売上(税抜)
*/
export const getDailySumHistory = `query getDailySumHistory($shop_id: Int, $date: String) {
  getDailySumHistory( shop_id: $shop_id, date: $date ) {
    id
    shopName
    sumDateTime
    sales
    net_sales
  }
}
`;


// 日次締め（月計）一覧 : 日次締め（月計）一覧を取得
/*
■リクエストパラメータ
shop_ids  店舗ID
date　検索対象日（YYYY-MM-DD）月計の場合は月初（例：2022年8月の場合⇒2022-08-01）を指定してください

■レスポンスパラメータ
id
shopName  店舗名／レジ名
sumDateTime 締め時間
sales       総売上(税込)
net_sales     純売上(税抜)
*/
export const getMonthlySumHistory = `query getMonthlySumHistory($shop_id: Int, $date: String) {
  getMonthlySumHistory( shop_id: $shop_id, date: $date ) {
    id
    shopName
    sumDateTime
    sales
    net_sales
  }
}
`;


// 日次締め一覧 : 日次締め詳細を取得
/*
■リクエストパラメータ
id  日次締め一覧で取得したid

■レスポンスパラメータ

現金残高
cashBalance {
  tenThousandYen  1万円札
  fiveThousandYen 5千円札
  twoThousandYen  2千円札
  oneThousandYen  千円札
  fiveHundredYen  500円玉
  oneHundredYen   100円玉
  fiftyYen        50円玉
  tenYen          10円玉
  fiveYen         5円玉
  oneYen          1円玉
}

現金取引
transaction {
  carryOver       繰越準備金
  depositCash     預り金
  charge          釣銭
  cashSales       現金売上
  calculateBalance  計算現金残高
  realBalance     実現金残高
  difference      現金過不足
}

精算明細
dailySum {
  subtotal		小計
  subtotalDiscountPrice		小計値引
  subtotalDiscountPriceNoTax		小計値引(内税抜)
  subtotalDiscountRate		小計割引
  subtotalDiscountRateNoTax		小計割引(内税抜)
  unitDiscountsubtotal		単品値割引
  unitDiscountsubtotalNoTax		単品値割引(内税抜)
  pointDiscount		ポイント利用
  couponDiscount		クーポン利用
  total		合計
  depositCash		現金受領
  deposit_Terminal		・JET-S
  depositCredit		・クレジット受領
  depositEMoney		・電子マネー受領
  depositQRcode		・QRコード受領
  depositTakeout		・テイクアウト受領
  depositMobile		・モバイル受領
  depositOther		・その他支払受領
  changeDifference		・釣銭差額
  delivery		・デリバリー
  deliveryUber		・Uber Eats
  deliveryDiDi		・DiDi Food
  deliveryDemaekan		・出前館
  deliveryFoodpanda		・foodpanda
  deliveryOther		・その他
  outTaxSalesTotalPer8		・外税対象額（8％）
  outTaxSalesTotalPer10		・外税対象額（10％）
  inTaxSalesTotalPer8		・内税対象額（8％）
  inTaxSalesTotalPer10		・内税対象額（10％）
  taxTotal		消費税
  taxInclude8		・内税額（8％）
  taxExclude8		・外税額（8％）
  taxInclude10		・内税額（10％）
  taxExclude10		・外税額（10％）
  pointUsageReduction		・ポイント利用減額
  returnTotal		返品計
  returnCash		・現金受領
  return_Terminal		・JET-S
  returnCredit		・クレジット受領
  returnEMoney		・電子マネー受領
  returnQRcode		・QRコード受領
  returnOther		・その他支払受領
  cancelTotal		取消計
  cancelCash		・現金受領
  cancel_Terminal		・JET-S
  cancelCredit		・クレジット受領
  cancelEMoney		・電子マネー受領
  cancelQRcode		・QRコード受領
  cancelOther		・その他支払受領
  salesTotal		総売上
  salesTotal8		総売上（8％）
  salesTotalInPoint8		総売上（8％）（ポイント含む）
  salesTotal10		総売上（10％）
  salesTotalInPoint10		総売上（10％）（ポイント含む）
  sales		純売上
  total8		純売上（8％）
  totalInPoint8		純売上（8％）（ポイント含む）
  total10		純売上（10％）
  totalInPoint10		純売上（10％）（ポイント含む）
  deductionTotal		控除合計(消費税 + 対象外)
  afterDeductionTotal		控除後合計
  salesTargetTotalInTax		売上対象(値引前)(内税込)
  salesTargetTotal		売上対象(値引前)(内税抜)
  amount		販売点数
  returnAmount		返品点数
  cancelAmount		取消点数
  spendPoint		使用ポイント
  pairs		組数
  totalTransactionCount		総取引数
  guestNumbers		客数
  guestNumbersTakeout		・客数（テイクアウト）
  customerUnitPrice		客単価
  transactionCount		通常取引数
  cashCount		・現金取引数
  count_Terminal		・JET-S
  creditCount		・クレジット受領数
  eMoneyCount		・電子マネー受領数
  QRcodeCount		・QRコード受領数
  mobileCount		・モバイル受領数
  otherTransaction		その他取引計
  receiptTotal		・入金計
  paymentTotal		・出金計
  addPointTotal		・ポイント加算計
  reducedPointTotal		・ポイント減算計
  otherTransactionCount		その他取引数
  addPointCount		・ポイント加算取引数
  addPointCancelCount		・ポイント加算取消取引数
  reducedPointCount		・ポイント減算取引数
  reducedPointCancelCount		・ポイント減算取消取引数
  receiptPaymentTotal		入出金合計金額
  receiptPaymentDetail		入出金明細
  denomination		金種計（枚）
  tenThousandYen      1万円札
  fiveThousandYen     5千円札
  twoThousandYen      2千円札
  oneThousandYen      千円札
  fiveHundredYen      500円玉
  oneHundredYen     100円玉
  fiftyYen      50円玉
  tenYen        10円玉
  fiveYen       5円玉
  oneYen        1円玉
  carryOver     繰越準備金
  realBalance    実現金残高
  difference      現金過不足
  payoffCount		通算精算回数
  mobileSalesTotal		モバイル売上（総売上）
  mobileTotal		モバイル売上（純売上）
  depositOthers {
    paymentMethodName		その他受領名
    depositOthersSum	その他受領売上計
  }
  categories {		
    categoryGroupName		カテゴリ別：カテゴリ名
    unitDiscountedSum		カテゴリ別：売上合計
  }
}
*/
export const getDailySum = `query getDailySum($id: Int) {
  getDailySum( id: $id ) {
    cashBalance {
      tenThousandYen
      fiveThousandYen
      twoThousandYen
      oneThousandYen
      fiveHundredYen
      oneHundredYen
      fiftyYen
      tenYen
      fiveYen
      oneYen
    }
    transaction {
      carryOver
      depositCash
      cashSales
      charge
      calculateBalance
      realBalance
      difference
    }
    dailySum {
      subtotal
      subtotalDiscountPrice
      subtotalDiscountPriceNoTax
      subtotalDiscountRate
      subtotalDiscountRateNoTax
      unitDiscountsubtotal
      unitDiscountsubtotalNoTax
      pointDiscount
      couponDiscount
      total
      depositCash
      deposit_Terminal
      depositCredit
      depositEMoney
      depositQRcode
      depositTakeout
      depositMobile
      depositOther
      changeDifference
      delivery
      deliveryUber
      deliveryDiDi
      deliveryDemaekan
      deliveryFoodpanda
      deliveryOther
      outTaxSalesTotalPer8
      outTaxSalesTotalPer10
      inTaxSalesTotalPer8
      inTaxSalesTotalPer10
      taxTotal
      taxInclude8
      taxExclude8
      taxInclude10
      taxExclude10
      pointUsageReduction
      returnTotal
      returnCash
      return_Terminal
      returnCredit
      returnEMoney
      returnQRcode
      returnOther
      cancelTotal
      cancelCash
      cancel_Terminal
      cancelCredit
      cancelEMoney
      cancelQRcode
      cancelOther
      salesTotal
      salesTotal8
      salesTotalInPoint8
      salesTotal10
      salesTotalInPoint10
      sales
      total8
      totalInPoint8
      total10
      totalInPoint10
      deductionTotal
      afterDeductionTotal
      salesTargetTotalInTax
      salesTargetTotal
      amount
      returnAmount
      cancelAmount
      spendPoint
      pairs
      totalTransactionCount
      guestNumbers
      guestNumbersTakeout
      customerUnitPrice
      transactionCount
      cashCount
      count_Terminal
      creditCount
      eMoneyCount
      QRcodeCount
      mobileCount
      otherTransaction
      receiptTotal
      paymentTotal
      addPointTotal
      reducedPointTotal
      otherTransactionCount
      addPointCount
      addPointCancelCount
      reducedPointCount
      reducedPointCancelCount
      receiptPaymentTotal
      receiptPaymentDetail
      denomination
      tenThousandYen
      fiveThousandYen
      twoThousandYen
      oneThousandYen
      fiveHundredYen
      oneHundredYen
      fiftyYen
      tenYen
      fiveYen
      oneYen
      carryOver
      realBalance
      difference
      payoffCount
      mobileSalesTotal
      mobileTotal
      depositOthers {
        paymentMethodName
        depositOthersSum
      }
      categories {
        categoryGroupName
        unitDiscountedSum
      }
    }
  }
}
`;


// 日次締め（月計）詳細を取得
/*
■リクエストパラメータ
shop_ids  店舗ID
date　検索対象日（YYYY-MM-DD）月計の場合は月初（例：2022年8月の場合⇒2022-08-01）を指定してください

■レスポンスパラメータ

現金残高
cashBalance {
  tenThousandYen  1万円札
  fiveThousandYen 5千円札
  twoThousandYen  2千円札
  oneThousandYen  千円札
  fiveHundredYen  500円玉
  oneHundredYen   100円玉
  fiftyYen        50円玉
  tenYen          10円玉
  fiveYen         5円玉
  oneYen          1円玉
}

現金取引
transaction {
  carryOver       繰越準備金
  depositCash     預り金
  charge          釣銭
  cashSales       現金売上
  calculateBalance  計算現金残高
  realBalance     実現金残高
  difference      現金過不足
}

精算明細
dailySum {
  id
  shop_id         店舗ID
  cashDrawerId    レジ端末ID
  storeCode       店舗コード
  sumDateTime　締め集計対象月（YYYY-MM）
  checkDateTime  現金チェック対象月（YYYY-MM）
  data {
      id
      displayIndex    表示順
      label           精算項目名
      values {
          value       精算項目値
      }
  }
}
*/
export const getMonthlySumVer2 = `query getMonthlySumVer2($shop_id: Int, $date: String) {
  getMonthlySumVer2(shop_id: $shop_id, date: $date) {
    cashBalance {
      tenThousandYen
      fiveThousandYen
      twoThousandYen
      oneThousandYen
      fiveHundredYen
      oneHundredYen
      fiftyYen
      tenYen
      fiveYen
      oneYen
    }
    transaction {
      carryOver
      depositCash
      cashSales
      charge
      calculateBalance
      realBalance
      difference
    }
    dailySum {
      id
      shop_id
      storeCode
      sumDateTime
      cashDrawerId
      checkDateTime
      data {
        displayIndex
        id
        label
        values {
          value
        }
      }
    }
  }
}
`;


// アカウントで閲覧権限のある店舗リストを取得
/*
■リクエストパラメータ
shopUUID  ログイン時に取得したUUID
※ログイン後のUUIDの取得
const data = await Auth.currentUserInfo();
const shopUUID = data.attributes.sub;

■レスポンスパラメータ
id  店舗ID
name  店舗名
site_type  店舗ブランド
*/
/*
export const getShopAccount = `query getShopAccount($shopUUID: String) {
  getShopAccount( shopUUID: $shopUUID ) {
    id
    name
    site_type
  }
}
`;
*/
/*
企業アカウントの管理店舗一覧を取得

■リクエストパラメータ
developerUuid     ユーザー認証用UUID

■レスポンス
id
site_type   店舗形態
name        店舗名称
brandId     ブランドID
brandName   ブランド名称
*/
export const getShopAccount20230722 = `query getShopAccount20230722( $developerUuid: String ) {
    getShopAccount20230722( developerUuid: $developerUuid ) {
        id
        site_type
        name
        brandId
        brandName
    }
}
`;








// 日次締め詳細を取得（一品香用）
/*
■リクエストパラメータ
id  日次締め一覧で取得したid

■レスポンスパラメータ

現金残高
cashBalance {
  tenThousandYen  1万円札
  fiveThousandYen 5千円札
  twoThousandYen  2千円札
  oneThousandYen  千円札
  fiveHundredYen  500円玉
  oneHundredYen   100円玉
  fiftyYen        50円玉
  tenYen          10円玉
  fiveYen         5円玉
  oneYen          1円玉
}

現金取引
transaction {
  carryOver       繰越準備金
  depositCash     預り金
  charge          釣銭
  cashSales       現金売上
  calculateBalance  計算現金残高
  realBalance     実現金残高
  difference      現金過不足
}

精算明細
dailySum {
  id
  shop_id         店舗ID
  cashDrawerId    レジ端末ID
  storeCode       店舗コード
  sumDateTime　締め日時（null or YYYY-MM-DD HH:mm:ss）
  checkDateTime  現金チェック日時（YYYY-MM-DD HH:mm:ss）
  data {
      id
      displayIndex    表示順
      label           精算項目名
      values {
          value       精算項目値
      }
  }
}
*/
export const getDailySumVer2 = `query getDailySumVer2($id: Int) {
  getDailySumVer2( id: $id ) {
    cashBalance {
      tenThousandYen
      fiveThousandYen
      twoThousandYen
      oneThousandYen
      fiveHundredYen
      oneHundredYen
      fiftyYen
      tenYen
      fiveYen
      oneYen
    }
    transaction {
      carryOver
      depositCash
      cashSales
      charge
      calculateBalance
      realBalance
      difference
    }
    dailySum {
      id
      shop_id
      storeCode
      sumDateTime
      cashDrawerId
      checkDateTime
      data {
        displayIndex
        id
        label
        values {
          value
        }
      }
    }
  }
}
`;


// VOID一覧を取得
/*
■リクエストパラメータ
shop_ids  店舗ID(配列)
fromDate　検索対象開始日（YYYY-MM-DD）
toDate　　検索対象終了日（YYYY-MM-DD）
limit     1回の取得件数
offset    ページネーション

■レスポンスパラメータ
count   総件数
total   VOID合計額
data {
  transactionDate		取引日付
  shopName		店舗名
  transactionTime		取引時間
  total		VOID金額
  staffName		会計担当
}
*/
export const getVoidList = `query getVoidList($shop_ids: [Int], $fromDate: String, $toDate: String, $limit: Int, $offset: Int) {
  getVoidList(shop_ids: $shop_ids, fromDate: $fromDate, toDate: $toDate, limit: $limit, offset: $offset) {
    count
    total
    data {
      id
      transactionDate
      shopName
      transactionTime
      total
      staffName
    }
  }
}
`;


/*
ログイン後にアカウントIDを取得

※ログイン認証周りがまだなので、テスト動作確認では以下のリクエストパラメータを使用してください。
"003a67a9-4f5a-4868-ba6e-00eb04f9a9eg"

■リクエストパラメータ
developerUuid     ユーザー認証用UUID

■レスポンス
developerId     アカウントID
developerName   アカウント名
invoice         インボイス登録番号
*/
export const getDeveloperAccount = `query getDeveloperAccount( $developerUuid: String ) {
    getDeveloperAccount( developerUuid: $developerUuid ) {
        developerId
        developerName
        invoice
        api_type
        authority
    }
}
`;

export const getDeveloperInvoice = `query getDeveloperInvoice( $developerUuid: String, $shop_id: Int ) {
    getDeveloperInvoice( developerUuid: $developerUuid, shop_id: $shop_id ) {
        developerId
        developerName
        invoice
        api_type
    }
}
`;


/*
新規ブランド作成

■リクエストパラメータ
input BrandInput {
  developerId     アカウントID
  brandName       ブランド名
  logoImageUrl    ブランドロゴ画像URL
}

■レスポンス
brandId     ブランドID
brandName   ブランド名
*/
export const createBrand = `mutation createBrand( $input: BrandInput ) {
    createBrand( input: $input ) {
        brandId
        brandName
    }
}
`;

/*
ブランド情報更新

■リクエストパラメータ
input BrandInput {
  brandId     ブランドID
  brandName       ブランド名
  logoImageUrl    ブランドロゴ画像URL（正方形ロゴ）
    logoRectImageUrl    ブランドロゴ画像URL（長方形ロゴ）
}

■レスポンス
brandId     ブランドID
brandName   ブランド名
*/
export const updateBrand = `mutation updateBrand( $input: BrandInput ) {
    updateBrand( input: $input ) {
        brandId
        brandName
    }
}
`;


/*
ブランド情報を削除

■リクエストパラメータ
brandId     ブランドID

■レスポンス
result      更新完了レスポンス
*/
export const deleteBrand = `mutation deleteBrand( $brandId: Int ) {
    deleteBrand( brandId: $brandId ) {
        result
    }
}
`;


/*
登録済みブランド一覧を取得

■リクエストパラメータ
developerId     アカウントID

■レスポンス
brandId     ブランドID
brandName   ブランド名
logoImageUrl    ブランドロゴ画像URL
*/
export const getBrandByDeveloper = `query getBrandByDeveloper( $developerId: Int ) {
    getBrandByDeveloper( developerId: $developerId ) {
        brandId
        brandName
        logoImageUrl
        logoRectImageUrl
    }
}
`;


/*
登録済み店舗一覧を取得

■リクエストパラメータ
developerId     アカウントID
prefCode        都道府県ID
keyword         キーワード

■レスポンス
brandId     ブランドID
brandName   ブランド名称
storeId     店舗ID
storeAdminId    （表示用）店舗ID
storeCode   店舗コード
storeName   店舗名
pref        都道府県
addr        住所
*/
export const getStoreByDeveloper = `query getStoreByDeveloper( $developerId: Int, $prefCode: Int, $keyword: String ) {
    getStoreByDeveloper20230722( developerId: $developerId, prefCode: $prefCode, keyword: $keyword ) {
        brandId
    	brandName
        storeId
        storeAdminId
        storeCode
        storeName
        pref
        addr
        operation_type
    }
}
`;

export const getStoreListByDeveloper = `query getStoreByDeveloper( $developerId: Int, $prefCode: Int, $keyword: String ) {
    getStoreByDeveloper( developerId: $developerId, prefCode: $prefCode, keyword: $keyword ) {
        brandId
    	brandName
        storeId
        storeAdminId
        storeCode
        storeName
        pref
        addr
    }
}
`;

/*
店舗情報を更新

■リクエストパラメータ
input StoreInput {
  developerId     アカウントID
  brandId         ブランドID
    genreId1        ジャンルID1
    genreId2        ジャンルID2
    genreId3        ジャンルID3
    gmoId           GMOショップID
    gmoPass         GMOショップパスワード
    storeId         店舗ID
  storeCode       店舗コード
  storeName       店舗名
    appCompatible   アプリ対応
    openAt          本運用開始日
  storeImageUrl   店舗外観画像
  recommendImages {
    recommendImageUrl   掲載画像
  }
  zip                 郵便番号
  prefCode            都道府県コード
  city                市区町村・番地
  streetAddr          建物・ビル名
  tel                 電話番号
  mapUrl              GoogleMap URL
  salesCategoryEatIn	販売対応区分（お店で注文）
    salesCategoryTakeout	販売対応区分（テイクアウト）
    salesCategoryEC		販売対応区分（ネット通販）
    ecSiteUrl
  pointReductionRate  Shopポイント還元率
  caption             店舗PR文
  businessHoursFormat 営業時間
  businessHoursJson
  businessHoursText
  holiday             定休日
  paymentMethodCash   支払方法（現金）
  paymentMethodCredit 支払方法（クレジットカード）
  paymentMethodIC     支払方法（電子マネー）
  paymentMethodQR     支払方法（QRコード）
  seatsTable          席数（テーブル）
  seatsCounter        席数（カウンター）
  parking             駐車場
  parkingNum          駐車場（台数）
    pickupParking       駐車場受取
  websiteUrl          ホームページURL
  budgetDay           予算（昼）
  budgetNight         予算（夜）
  reserve             予約可否
    reserveTel          予約用電話番号
  privateRoom         個室
  privateRoomNum      個室（部屋数）
  smoking             喫煙・禁煙
    releaseTimer        公開タイマー
    legal {
        sellerName	販売事業者の名称
        zip		郵便番号
        prefCode	都道府県コード
        address1	市区町村・番地
        address2	建物・ビル名
        representative	代表者の名称
        contactUrl	問い合わせ先URL
        tel		問い合わせ先電話番号
        aboutSalesPrice			販売価格
        aboutPaymentMethodEatin		支払方法・店内注文
        aboutPaymentMethodTakeout	支払方法・テイクアウト注文
        aboutDelivery			商品の受け渡し
        aboutReturnExchange		返品・交換
        aboutTax		消費税
        aboutCancelEatin	キャンセル・店内注文
        aboutCancelTakeout	キャンセル・テイクアウト
    }
}

■レスポンス
developerId
brandId
genreId1
genreId2
genreId3
gmoId
gmoPass
kitchenMonitorUUID
storeId
storeCode
storeName
storeImageUrl
appCompatible
openAt
recommendImages {
    recommendImageUrl
}
zip
prefCode
city
streetAddr
tel
mapUrl
salesCategoryEatIn
salesCategoryTakeout
salesCategoryEC
ecSiteUrl
pointReductionRate
caption
businessHoursFormat
businessHoursJson
businessHoursText
holiday
paymentMethodCash
paymentMethodCredit
paymentMethodIC
paymentMethodQR
seatsTable
seatsCounter
parking
parkingNum
pickupParking
websiteUrl
budgetDay
budgetNight
reserve
reserveTel
privateRoom
privateRoomNum
smoking
releaseTimer
legal {
    developerId
    sellerName
    zip
    prefCode
    address1
    address2
    representative
    contactUrl
    tel
    aboutSalesPrice
    aboutPaymentMethodEatin
    aboutPaymentMethodTakeout
    aboutDelivery
    aboutReturnExchange
    aboutTax
    aboutCancelEatin
    aboutCancelTakeout
}
*/
export const updateStore = `mutation updateStore( $input: StoreInput ) {
    updateStore( input: $input ) {
        developerId
	    brandId
	    genreId1
        genreId2
        genreId3
        gmoId
        gmoPass
        kitchenMonitorUUID
        storeId
	    storeCode
	    storeName
	    storeImageUrl
        appCompatible
        openAt
	    recommendImages {
	    	recommendImageUrl
	    }
	    zip
	    prefCode
	    city
	    streetAddr
	    tel
      telOption
	    mapUrl
	    salesCategoryEatIn
        salesCategoryTakeout
        salesCategoryEC
        ecSiteUrl
	    pointReductionRate
	    caption
	    businessHoursFormat
	    businessHoursJson
	    businessHoursText
	    holiday
      temporary_holiday
	    paymentMethodCash
	    paymentMethodCredit
	    paymentMethodIC
	    paymentMethodQR
	    seatsTable
	    seatsCounter
	    parking
	    parkingNum
        pickupParking
	    websiteUrl
	    budgetDay
	    budgetNight
	    reserve
        reserveTel
	    privateRoom
	    privateRoomNum
	    smoking
        releaseTimer
        legal {
            sellerName
            zip
            prefCode
            address1
            address2
            representative
            contactUrl
            tel
            aboutSalesPrice
            aboutPaymentMethodEatin
            aboutPaymentMethodTakeout
            aboutDelivery
            aboutReturnExchange
            aboutTax
            aboutCancelEatin
            aboutCancelTakeout
        }
    }
}
`;


/*
店舗を削除

■リクエストパラメータ
storeId     店舗ID

■レスポンス
result      更新完了レスポンス
*/
export const deleteStore = `mutation deleteStore( $storeId: Int ) {
    deleteStore( storeId: $storeId ) {
        result
    }
}
`;


/*
選択用：ジャンル一覧を取得

■リクエストパラメータ
なし

■レスポンス
genreId     ジャンルID
genreName   ジャンル名
*/
export const getGenreList = `query getGenreList {
    getGenreList {
        genreId
        genreName
    }
}
`;


/*
選択用：都道府県一覧を取得

■リクエストパラメータ
なし

■レスポンス
prefCode     都道府県コード
prefName   都道府県名称

*/
export const getPrefList = `query getPrefList {
    getPrefList {
        prefCode
        prefName
    }
}
`;


/*
登録済み店舗詳細を取得

■リクエストパラメータ
storeId     店舗ID

■レスポンス
developerId     アカウントID
brandId         ブランドID
genreId1        ジャンルID1
genreId2        ジャンルID2
genreId3        ジャンルID3
gmoId           GMOショップID
gmoPass         GMOショップパスワード
kitchenMonitorUUID  キッチンモニターデバイスID
storeCode       店舗コード
storeName       店舗名
storeImageUrl   店舗外観画像
appCompatible   アプリ対応
openAt          本運用開始日
recommendImages {
    recommendImageUrl   掲載画像
}
zip                 郵便番号
prefCode            都道府県コード
city                市区町村・番地
streetAddr          建物・ビル名
tel                 電話番号
mapUrl              GoogleMap URL
salesCategoryEatIn	販売対応区分（お店で注文）
salesCategoryTakeout	販売対応区分（テイクアウト）
salesCategoryEC		販売対応区分（ネット通販）
ecSiteUrl           ECサイトURL
pointReductionRate  Shopポイント還元率
caption             店舗PR文
businessHoursFormat 営業時間
businessHoursJson
businessHoursText
holiday             定休日
paymentMethodCash   支払方法（現金）
paymentMethodCredit 支払方法（クレジットカード）
paymentMethodIC     支払方法（電子マネー）
paymentMethodQR     支払方法（QRコード）
seatsTable          席数（テーブル）
seatsCounter        席数（カウンター）
parking             駐車場
parkingNum          駐車場（台数）
pickupParking       駐車場受取
websiteUrl          ホームページURL
budgetDay           予算（昼）
budgetNight         予算（夜）
reserve             予約可否
reserveTel          予約用電話番号
privateRoom         個室
privateRoomNum      個室（部屋数）
smoking             喫煙・禁煙
releaseTimer        公開タイマー
legal {
    sellerName	販売事業者の名称
    zip		郵便番号
    prefCode	都道府県コード
    address1	市区町村・番地
    address2	建物・ビル名
    representative	代表者の名称
    contactUrl	問い合わせ先URL
    tel		問い合わせ先電話番号
    aboutSalesPrice			販売価格
    aboutPaymentMethodEatin		支払方法・店内注文
    aboutPaymentMethodTakeout	支払方法・テイクアウト注文
    aboutDelivery			商品の受け渡し
    aboutReturnExchange		返品・交換
    aboutTax		消費税
    aboutCancelEatin	キャンセル・店内注文
    aboutCancelTakeout	キャンセル・テイクアウト
}
*/
export const getStoreRawData = `query getStoreRawData( $storeId: Int ) {
    getStoreRawData( storeId: $storeId ) {
        developerId
	    brandId
	    genreId1
        genreId2
        genreId3
        gmoId
        gmoPass
        kitchenMonitorUUID
	    storeCode
	    storeName
	    storeImageUrl
        appCompatible
        openAt
	    recommendImages {
	    	recommendImageUrl
	    }
	    zip
	    prefCode
	    city
	    streetAddr
	    tel
      telOption
	    mapUrl
	    salesCategoryEatIn
        salesCategoryTakeout
        salesCategoryEC
        ecSiteUrl
	    pointReductionRate
	    caption
	    businessHoursFormat
	    businessHoursJson
	    businessHoursText
	    holiday
      temporary_holiday
	    paymentMethodCash
	    paymentMethodCredit
	    paymentMethodIC
	    paymentMethodQR
	    seatsTable
	    seatsCounter
	    parking
	    parkingNum
        pickupParking
	    websiteUrl
	    budgetDay
	    budgetNight
	    reserve
        reserveTel
	    privateRoom
	    privateRoomNum
	    smoking
      fair
      operation_type
        releaseTimer
        legal {
            sellerName
            zip
            prefCode
            address1
            address2
            representative
            contactUrl
            tel
            aboutSalesPrice
            aboutPaymentMethodEatin
            aboutPaymentMethodTakeout
            aboutDelivery
            aboutReturnExchange
            aboutTax
            aboutCancelEatin
            aboutCancelTakeout
        }
    }
}
`;


/*
新規店舗作成

■リクエストパラメータ
input StoreInput {
  developerId     アカウントID
  brandId         ブランドID
    genreId1        ジャンルID1
    genreId2        ジャンルID2
    genreId3        ジャンルID3
    gmoId           GMOショップID
    gmoPass         GMOショップパスワード
  storeCode       店舗コード
  storeName       店舗名
    appCompatible   アプリ対応
    openAt          本運用開始日
  storeImageUrl   店舗外観画像
  recommendImages {
    recommendImageUrl   掲載画像
  }
  zip                 郵便番号
  prefCode            都道府県コード
  city                市区町村・番地
  streetAddr          建物・ビル名
  tel                 電話番号
  mapUrl              GoogleMap URL
  salesCategoryEatIn	販売対応区分（お店で注文）
    salesCategoryTakeout	販売対応区分（テイクアウト）
    salesCategoryEC		販売対応区分（ネット通販）
    ecSiteUrl
  pointReductionRate  Shopポイント還元率
  caption             店舗PR文
  businessHoursFormat 営業時間
  businessHoursJson
  businessHoursText
  holiday             定休日
  paymentMethodCash   支払方法（現金）
  paymentMethodCredit 支払方法（クレジットカード）
  paymentMethodIC     支払方法（電子マネー）
  paymentMethodQR     支払方法（QRコード）
  seatsTable          席数（テーブル）
  seatsCounter        席数（カウンター）
  parking             駐車場
  parkingNum          駐車場（台数）
    pickupParking       駐車場受取
  websiteUrl          ホームページURL
  budgetDay           予算（昼）
  budgetNight         予算（夜）
  reserve             予約可否
    reserveTel          予約用電話番号
  privateRoom         個室
  privateRoomNum      個室（部屋数）
  smoking             喫煙・禁煙
    releaseTimer        公開タイマー
    legal {
        sellerName	販売事業者の名称
        zip		郵便番号
        prefCode	都道府県コード
        address1	市区町村・番地
        address2	建物・ビル名
        representative	代表者の名称
        contactUrl	問い合わせ先URL
        tel		問い合わせ先電話番号
        aboutSalesPrice			販売価格
        aboutPaymentMethodEatin		支払方法・店内注文
        aboutPaymentMethodTakeout	支払方法・テイクアウト注文
        aboutDelivery			商品の受け渡し
        aboutReturnExchange		返品・交換
        aboutTax		消費税
        aboutCancelEatin	キャンセル・店内注文
        aboutCancelTakeout	キャンセル・テイクアウト
    }
}

■レスポンス
developerId
brandId
genreId1
genreId2
genreId3
gmoId
gmoPass
kitchenMonitorUUID
storeId
storeCode
storeName
storeImageUrl
appCompatible
openAt
recommendImages {
    recommendImageUrl
}
zip
prefCode
city
streetAddr
tel
mapUrl
salesCategoryEatIn
salesCategoryTakeout
salesCategoryEC
ecSiteUrl
pointReductionRate
caption
businessHoursFormat
businessHoursJson
businessHoursText
holiday
paymentMethodCash
paymentMethodCredit
paymentMethodIC
paymentMethodQR
seatsTable
seatsCounter
parking
parkingNum
pickupParking
websiteUrl
budgetDay
budgetNight
reserve
reserveTel
privateRoom
privateRoomNum
smoking
releaseTimer
legal {
    developerId
    sellerName
    zip
    prefCode
    address1
    address2
    representative
    contactUrl
    tel
    aboutSalesPrice
    aboutPaymentMethodEatin
    aboutPaymentMethodTakeout
    aboutDelivery
    aboutReturnExchange
    aboutTax
    aboutCancelEatin
    aboutCancelTakeout
}
*/
export const createStore = `mutation createStore( $input: StoreInput ) {
    createStore( input: $input ) {
        developerId
	    brandId
	    genreId1
        genreId2
        genreId3
        gmoId
        gmoPass
        kitchenMonitorUUID
        storeId
	    storeCode
	    storeName
	    storeImageUrl
        appCompatible
        openAt
	    recommendImages {
	    	recommendImageUrl
	    }
	    zip
	    prefCode
	    city
	    streetAddr
	    tel
	    mapUrl
	    salesCategoryEatIn
        salesCategoryTakeout
        salesCategoryEC
        ecSiteUrl
	    pointReductionRate
	    caption
	    businessHoursFormat
	    businessHoursJson
	    businessHoursText
	    holiday
      temporary_holiday
	    paymentMethodCash
	    paymentMethodCredit
	    paymentMethodIC
	    paymentMethodQR
	    seatsTable
	    seatsCounter
	    parking
	    parkingNum
        pickupParking
	    websiteUrl
	    budgetDay
	    budgetNight
	    reserve
        reserveTel
	    privateRoom
	    privateRoomNum
	    smoking
        releaseTimer
        legal {
            sellerName
            zip
            prefCode
            address1
            address2
            representative
            contactUrl
            tel
            aboutSalesPrice
            aboutPaymentMethodEatin
            aboutPaymentMethodTakeout
            aboutDelivery
            aboutReturnExchange
            aboutTax
            aboutCancelEatin
            aboutCancelTakeout
        }
    }
}
`;



/*
登録済みカテゴリー一覧を取得

■リクエストパラメータ
storeId     店舗ID
orderType   販売区分（1:イートイン  2:テイクアウト　3:※未設定  4:デリバリー）

■レスポンス
categoryId: Int         カテゴリーID
categoryAdminId: Int         （※表示用）カテゴリーID
categoryName: String    カテゴリー名称
brandId: Int            ブランドID
storeId: Int            店舗ID
orderType: Int          販売区分
displaySequence: Int    表示順
*/
export const getCategoryList = `query getCategoryList( $storeId: Int, $orderType: Int ) {
    getCategoryList( storeId: $storeId, orderType: $orderType ) {
        id
        categoryId
        categoryAdminId
        categoryName
        categoryNameEn
        categoryNameCn
        categoryNameKr
        brandId
        storeId
        orderType
        displaySequence
        delivery_target
        delivery_target_shops
        delivery_target_region
    }
}
`;


/*
登録済みトッピング一覧を取得

■リクエストパラメータ
storeId     店舗ID
orderType   販売区分（1:イートイン  2:テイクアウト　3:※未設定  4:デリバリー）

■レスポンス
productId: Int          商品ID
productAdminId: Int     （※表示用）商品ID
productCode: String     商品コード
productName: String     商品名
productNameEn: String   商品名（英）
price: Int              価格
taxRate: Int            税率
cost: Float             原価
displaySequence         表示順
*/
export const getProductOptionList = `query getProductOptionList( $storeId: Int, $orderType: Int ) {
    getProductOptionList( storeId: $storeId, orderType: $orderType ) {
        productId
        productAdminId
        productCode
        productName
        productNameEn
        productNameCn
        productNameKr
        price
        cost
        taxRate
        displaySequence
        updateProduct {
            updateProductId
            updateTimer
            price
            cost
        }
        topping_required
        printerAddrId1
        printerAddrId2
        printerAddrId3
        printerAddrId4
    }
}
`;


/*
新規カテゴリー作成

■リクエストパラメータ
storeId     店舗ID
orderType   販売区分（1:イートイン  2:テイクアウト　3:※未設定  4:デリバリー）
categoryName: String    カテゴリー名称

■レスポンス
categoryId: Int         カテゴリーID
categoryName: String    カテゴリー名称
brandId: Int            ブランドID
storeId: Int            店舗ID
orderType: Int          販売区分
displaySequence: Int    表示順
*/
export const createProductCategory = `mutation createProductCategory( $storeId: Int, $orderType: Int, $categoryName: String, $categoryNameEn: String, $categoryNameCn: String, $categoryNameKr: String ) {
    createProductCategory( storeId: $storeId, orderType: $orderType, categoryName: $categoryName, categoryNameEn: $categoryNameEn, categoryNameCn: $categoryNameCn, categoryNameKr: $categoryNameKr ) {
        categoryId
        categoryName
        categoryNameEn
        categoryNameCn
        categoryNameKr
        brandId
        storeId
        orderType
        displaySequence
    }
}
`;

/*
カテゴリーを更新

■リクエストパラメータ
input CategoryInput {
  storeId: Int            店舗ID
  orderType   販売区分（1:イートイン  2:テイクアウト　3:※未設定  4:デリバリー）
  categoryId: Int         カテゴリーID
  categoryName: String    カテゴリー名称
}

■レスポンス
categoryId: Int         カテゴリーID
categoryName: String    カテゴリー名称
brandId: Int            ブランドID
storeId: Int            店舗ID
orderType: Int          販売区分
displaySequence: Int    表示順
*/
export const updateProductCategory = `mutation updateProductCategory( $input: CategoryInput ) {
    updateProductCategory( input: $input ) {
        categoryId
        categoryName
        categoryNameEn
        brandId
        storeId
        orderType
        displaySequence
    }
}
`;

/*
カテゴリーを削除

■リクエストパラメータ
categoryId: Int         カテゴリーID

■レスポンス
result      更新完了レスポンス
*/
export const deleteProductCategory = `mutation deleteProductCategory( $storeId: Int, $categoryId: Int, $orderType: Int ) {
    deleteProductCategory( storeId: $storeId, categoryId: $categoryId, orderType: $orderType ) {
        result
    }
}
`;



export const createMstProductCategory = `mutation createMstProductCategory( $storeId: Int, $orderType: Int, $categoryName: String, $categoryNameEn: String, $categoryNameCn: String, $categoryNameKr: String, $delivery_target: Int, $delivery_target_region: String, $delivery_target_shops
: String ) {
    createMstProductCategory( storeId: $storeId, orderType: $orderType, categoryName: $categoryName, categoryNameEn: $categoryNameEn, categoryNameCn: $categoryNameCn, categoryNameKr: $categoryNameKr, delivery_target: $delivery_target, delivery_target_region: $delivery_target_region, delivery_target_shops: $delivery_target_shops ) {
        categoryId
        categoryName
        categoryNameEn
        categoryNameCn
        categoryNameKr
        brandId
        storeId
        orderType
        displaySequence
        delivery_target
        delivery_target_shops
        delivery_target_region
    }
}
`;

export const updateMstProductCategory = `mutation updateMstProductCategory( $input: CategoryInput ) {
    updateMstProductCategory( input: $input ) {
        id
        categoryId
        categoryName
        categoryNameEn
        brandId
        storeId
        orderType
        displaySequence
        delivery_target
        delivery_target_shops
        delivery_target_region
    }
}
`;

export const deleteMstProductCategory = `mutation deleteMstProductCategory( $id: Int ) {
    deleteMstProductCategory( id: $id ) {
        result
    }
}
`;












/*
カテゴリー並び順を更新

■リクエストパラメータ
categoryId: Int         カテゴリーID
orderType: Int          販売区分
displaySequence: Int    表示順

■レスポンス
categoryId: Int         カテゴリーID
categoryName: String    カテゴリー名称
brandId: Int            ブランドID
storeId: Int            店舗ID
orderType: Int          販売区分
displaySequence: Int    表示順
*/
export const updateDisplaySequenceByCategory = `mutation updateDisplaySequenceByCategory( $storeId: Int, $categoryId: Int, $orderType: Int, $displaySequence: Int ) {
    updateDisplaySequenceByCategory( storeId: $storeId, categoryId: $categoryId, orderType: $orderType, displaySequence: $displaySequence ) {
        categoryId
        categoryName
        brandId
        storeId
        orderType
        displaySequence
    }
}
`;
/*
export const updateDisplaySequenceByProduct = `mutation updateDisplaySequenceByProduct( $productId: Int, $displaySequence: Int ) {
    updateDisplaySequenceByProduct( productId: $productId, displaySequence: $displaySequence ) {
        productId
        productCode
        productName
        price
        cost
        taxRate
    }
}
`;
*/
/*
商品の並び順を更新

■リクエストパラメータ
productId: Int         商品ID
displaySequence: Int    表示順

■レスポンス
storeId: Int            店舗ID
orderType: Int          販売区分
categoryId: Int         カテゴリーID
productId: Int          商品ID
productAdminId: Int     表示用商品ID
productCode: String     商品コード
productName: String     商品名
displaySequence: Int    表示順
*/
export const updateDisplaySequenceByProduct = `mutation updateDisplaySequenceByProduct( $productId: Int, $displaySequence: Int ) {
    updateDisplaySequenceByProduct( productId: $productId, displaySequence: $displaySequence ) {
        storeId
        orderType
        categoryId
        productId
        productAdminId
        productCode
        productName
        displaySequence
    }
}
`;

/*
商品の並び順を更新

■リクエストパラメータ
productId: Int         商品ID
displaySequence: Int    表示順

■レスポンス
storeId: Int            店舗ID
orderType: Int          販売区分
categoryId: Int         カテゴリーID
productId: Int          商品ID
productAdminId: Int     表示用商品ID
productCode: String     商品コード
productName: String     商品名
displaySequence: Int    表示順
*/
export const updateDisplaySequenceByInbound = `mutation updateDisplaySequenceByInbound( $productId: Int, $ibDisplaySequence: Int ) {
    updateDisplaySequenceByInbound( productId: $productId, ibDisplaySequence: $ibDisplaySequence ) {
        storeId
        orderType
        categoryId
        productId
        productAdminId
        productCode
        productName
        ib_displaySequence
    }
}
`;

/*
トッピングの並び順を更新

■リクエストパラメータ
productId: Int         商品ID
displaySequence: Int    表示順

■レスポンス
storeId: Int            店舗ID
orderType: Int          販売区分
productId: Int          商品ID
productAdminId: Int     表示用商品ID
productCode: String     商品コード
productName: String     商品名
displaySequence: Int    表示順
*/
export const updateDisplaySequenceByOption = `mutation updateDisplaySequenceByOption( $productId: Int, $displaySequence: Int ) {
    updateDisplaySequenceByOption( productId: $productId, displaySequence: $displaySequence ) {
        storeId
        orderType
        productId
        productAdminId
        productCode
        productName
        displaySequence
    }
}
`;

/*
トッピング新規登録

■リクエストパラメータ
input ProductInput {
  storeId: Int!           店舗ID
  orderType: Int!         販売区分（1:イートイン  2:テイクアウト　3:※未設定  4:デリバリー）
  productCode: String     商品コード
  productName: String     商品名
  price: Int              価格
  cost: Float             原価
}

■レスポンス
storeId: Int            店舗ID
orderType: Int          販売区分
productId: Int          商品ID
productCode: String     商品コード
productName: String     商品名
price: Int              価格
taxRate: Int            税率
cost: Float             原価
*/
export const createProductOption = `mutation createProductOption( $input: ProductInput ) {
    createProductOption( input: $input ) {
        storeId
        orderType
        productId
        productCode
        productName
         productNameEn
       price
        taxRate
        cost
        updateProduct {
            updateProductId
            updateTimer
            price
        }
        topping_required
        printerAddrId1
        printerAddrId2
        printerAddrId3
        printerAddrId4

    }
}
`;


export const createMstProductOption = `mutation createMstProductOption( $input: ProductInput ) {
    createMstProductOption( input: $input ) {
        storeId
        orderType
        productId
        productCode
        productName
         productNameEn
       price
        taxRate
        cost
        updateProduct {
            updateProductId
            updateTimer
            price
        }
        topping_required
        printerAddrId1
        printerAddrId2
        printerAddrId3
        printerAddrId4

    }
}
`;

/*
トッピング情報を更新

■リクエストパラメータ
input ProductInput {
  storeId: Int!           店舗ID
  orderType: Int!         販売区分（1:イートイン  2:テイクアウト　3:※未設定  4:デリバリー）
  productCode: String     商品コード
  productName: String     商品名
  price: Int              価格
  cost: Float             原価
}

■レスポンス
storeId: Int            店舗ID
orderType: Int          販売区分
productId: Int          商品ID
productCode: String     商品コード
productName: String     商品名
price: Int              価格
taxRate: Int            税率
cost: Float             原価
*/
export const updateProductOption = `mutation updateProductOption( $input: ProductInput ) {
    updateProductOption( input: $input ) {
        storeId
        orderType
        productId
        productCode
        productName
        productNameEn
        price
        taxRate
        cost
        updateProduct {
            updateProductId
            updateTimer
            price
        }
        topping_required
        printerAddrId1
        printerAddrId2
        printerAddrId3
        printerAddrId4
    }
}
`;


export const updateMstProductOption = `mutation updateMstProductOption( $input: ProductInput ) {
    updateMstProductOption( input: $input ) {
        storeId
        orderType
        productId
        productCode
        productName
        productNameEn
        price
        taxRate
        cost
        updateProduct {
            updateProductId
            updateTimer
            price
        }
        topping_required
        printerAddrId1
        printerAddrId2
        printerAddrId3
        printerAddrId4
    }
}
`;

/*
トッピング情報を削除

■リクエストパラメータ
productId: Int          商品ID

■レスポンス
result      更新完了レスポンス
*/
export const deleteProductOption = `mutation deleteProductOption( $productId: Int ) {
    deleteProductOption( productId: $productId ) {
        result
    }
}
`;

export const deleteMstProductOption = `mutation deleteMstProductOption( $productId: Int ) {
    deleteMstProductOption( productId: $productId ) {
        result
    }
}
`;


/*
登録済み商品一覧を取得

■リクエストパラメータ
storeId     店舗ID
orderType   販売区分（1:イートイン  2:テイクアウト　3:※未設定  4:デリバリー）
categoryId  カテゴリーID
keyword     検索キーワード

■レスポンス
productId: Int          商品ID
productAdminId: Int          （※表示用）商品ID
productCode: Int        商品コード
imageUrl: String        商品画像URL
categoryName: String    カテゴリー名称
productName: String     商品名
price: Int              単価
cost: Int              原価
printerAddrId1: Int     プリンタID1
printerAddrId2: Int     プリンタID2
printerAddrId3: Int     プリンタID3
printerAddrId4: Int     プリンタID4
displaySequence: int    表示順
optionProducts {
    productId: Int          商品ID
    productCode: Int        商品コード
    productName: String     商品名
    price: Int              単価
}
*/
export const getProductListByDeveloper = `query getProductListByDeveloper( 
  $storeId: Int, 
  $orderType: Int, 
  $delivery_type: Int, 
  $categoryId: Int, 
  $keyword: String
  $menuCategoryId: Int
   ) {
    getProductListByDeveloper( 
      storeId: $storeId, 
      orderType: $orderType, 
      delivery_type: $delivery_type,
      categoryId: $categoryId,
      keyword: $keyword
      menuCategoryId: $menuCategoryId
       ) {
      deliveryType
      delivery {
        deliveryId
        deliveryName
      }
      productId
      productAdminId
      productCode
      imageUrl
      categoryName
      productName
      price
      cost
      printerAddrId1
      printerAddrId2
      printerAddrId3
      printerAddrId4
      displaySequence
      optionProducts {
        productId
        productCode
        productName
        price
        displaySequence
      }
      cutlery
      thumbnailSize
    }
}
`;

/*
登録済み商品一覧を取得

■リクエストパラメータ
storeId     店舗ID
orderType   販売区分（1:イートイン  2:テイクアウト　3:※未設定  4:デリバリー）
categoryId  カテゴリーID
keyword     検索キーワード

■レスポンス
productId: Int          商品ID
productAdminId: Int          （※表示用）商品ID
productCode: Int        商品コード
imageUrl: String        商品画像URL
categoryName: String    カテゴリー名称
productName: String     商品名
price: Int              単価
cost: Int              原価
printerAddrId1: Int     プリンタID1
printerAddrId2: Int     プリンタID2
printerAddrId3: Int     プリンタID3
printerAddrId4: Int     プリンタID4
displaySequence: int    表示順
optionProducts {
    productId: Int          商品ID
    productCode: Int        商品コード
    productName: String     商品名
    price: Int              単価
ib_displaySequence: int    Recommend商品表示順
*/
export const getInboundProductListByDeveloper = `query getInboundProductListByDeveloper( 
  $storeId: Int, 
  $orderType: Int, 
  $delivery_type: Int, 
  $categoryId: Int, 
  $keyword: String
  $menuCategoryId: Int
   ) {
    getInboundProductListByDeveloper( 
      storeId: $storeId, 
      orderType: $orderType, 
      delivery_type: $delivery_type,
      categoryId: $categoryId,
      keyword: $keyword
      menuCategoryId: $menuCategoryId
       ) {
      deliveryType
      delivery {
        deliveryId
        deliveryName
      }
      productId
      productAdminId
      productCode
      imageUrl
      categoryName
      productName
      price
      cost
      printerAddrId1
      printerAddrId2
      printerAddrId3
      printerAddrId4
      displaySequence
      optionProducts {
        productId
        productCode
        productName
        price
        displaySequence
      }
      cutlery
      thumbnailSize
      ib_displaySequence
    }
}
`;

/*
新規商品ー作成

■リクエストパラメータ
input ProductInput {
  storeId: Int!
  orderType: Int!
    delivery {
        deliveryId: Int
    }
  categoryId: Int
  productCode: String
  productName: String
    productNameEn: String
  imageUrl: String
  description: String
    descriptionEn: String
  price: Int
  cost: Float
    updateProduct: Array {
        updateTimer: String
        price: Int
        cost: Float
    }
    countProduct: {
        countProductId: Int
        quantity: Int
    }
  printerAddrId1: Int
  printerAddrId2: Int
  printerAddrId3: Int
  printerAddrId4: Int
  releaseTimer: String
  optionProducts: {
        productId: Int
    }
}

■レスポンス
storeId: Int            店舗ID
orderType               販売区分（1:イートイン  2:テイクアウト　3:※未設定  4:デリバリー）
categoryId: Int         カテゴリーID
delivery {
    deliveryId: Int       デリバリーID（1:Uber  2:出前館  3:Wolt  4:menu  99:その他）
    deliveryName: String    デリバリー名称
}
productId: Int          商品ID
productCode: String     商品コード
productName: String     商品名
productNameEn: String   商品名（英）
imageUrl: String        商品画像URL
description: String     商品内容
descriptionEn: String   商品内容（英）
price: Int              価格
taxRate: Int            税率
cost: Float             原価
releaseTimer: String    公開タイマー
updateProduct: Array {
    updateProductId: Int
    updateTimer: String     改定設定日時
    price: Int              改定単価
    cost: Float             改定原価
}
countProduct: {
    countProductId: Int     カウント商品ID
    quantity: Int           カウント商品数量
}
printerAddrId1: Int     チビ券出力先1
printerAddrId2: Int     チビ券出力先2
printerAddrId3: Int     チビ券出力先3
printerAddrId4: Int     チビ券出力先4
optionProducts: {
    productId
    productName
}
*/
export const createProduct = `mutation createProduct( $input: ProductInput ) {
    createProduct( input: $input ) {
        storeId
        orderType
        categoryId
        delivery {
            deliveryId
            deliveryName
        }
        productId
        productCode
        productName
        productNameEn
        productNameCn
        productNameKr
        imageUrl
        description
        descriptionEn
        descriptionCn
        descriptionKr
        price
        taxRate
        releaseTimer
        updateProduct {
            updateProductId
            updateTimer
            price
            cost
        }
        countProduct {
            countProductId
            quantity
        }
        printerAddrId1
        printerAddrId2
        printerAddrId3
        printerAddrId4
        optionProducts {
            productId
            productName
        }
        cutlery
        thumbnailSize
        inbound
        is_recommended
    }
}
`;


/*
商品情報を削除

■リクエストパラメータ
productId: Int          商品ID

■レスポンス
result      更新完了レスポンス
*/
export const deleteProduct = `mutation deleteProduct( $productId: Int ) {
    deleteProduct( productId: $productId ) {
        result
    }
}
`;

export const deleteMstProduct = `mutation deleteMstProduct( $productId: Int ) {
    deleteMstProduct( productId: $productId ) {
        result
    }
}
`;


/*
登録済みカウント商品を取得

■リクエストパラメータ
storeId             店舗ID

■レスポンス
storeId             店舗ID
countProductId      カウント商品ID
countProductName    カウント商品名
*/
export const getCountProductList = `query getCountProductList( $storeId: Int ) {
    getCountProductList( storeId: $storeId ) {
        storeId
        countProductId
        countProductName
    }
}
`;

/*
カウント商品を削除

■リクエストパラメータ
input CountProductInput {
    countProductId    カウント商品ID
}

■レスポンス
result      更新完了レスポンス
*/
export const deleteCountProduct = `mutation deleteCountProduct( $input: [CountProductInput] ) {
    deleteCountProduct( input: $input ) {
        result
    }
}
`;

/*
店舗で使用可能なプリンタID一覧を取得

■リクエストパラメータ
storeId             店舗ID

■レスポンス
printerId           プリンタID
*/
export const getPrinterIds = `query getPrinterIds( $storeId: Int ) {
    getPrinterIds( storeId: $storeId ) {
        printerId
    }
}
`;


/*
登録済み商品データ詳細を取得

■リクエストパラメータ
productId: Int          商品ID

■レスポンス
categoryId: Int         カテゴリーID
delivery {
    deliveryId: Int       デリバリーID（1:Uber  2:出前館  3:Wolt  4:menu  99:その他）
    deliveryName: String    デリバリー名称
}
productId: Int          商品ID
productCode: String     商品コード
productName: String     商品名
imageUrl: String        商品画像URL
description: String     商品内容
descriptionEn: String   商品内容（英）
price: Int              価格
taxRate: Int            税率
cost: Float             原価
releaseTimer            公開日時
updateProduct: Array {
    updateProductId: Int
    updateTimer: String     改定設定日時
    price: Int              改定単価
    cost: Float             改定原価
}
countProduct: {
    countProductId: Int     カウント商品ID
    quantity: Int           カウント商品数量
}
printerAddrId1: Int     チビ券出力先1
printerAddrId2: Int     チビ券出力先2
printerAddrId3: Int     チビ券出力先3
printerAddrId4: Int     チビ券出力先4
optionProducts: {
    productId
    productName
}
*/
export const getProduct = `query getProduct( $productId: Int ) {
    getProduct( productId: $productId ) {
        categoryId
        delivery {
            deliveryId
            deliveryName
        }
        productId
        productCode
        menuCategory {
          menuCategoryId
          masterProductId
        }
        productName
        productNameEn
        productNameCn
        productNameKr
        imageUrl
        description
        descriptionEn
        descriptionCn
        descriptionKr
        price
        taxRate
        cost
        releaseTimer
        updateProduct {
            updateProductId
            updateTimer
            price
            cost
        }
        countProduct {
            countProductId
            quantity
        }
        printerAddrId1
        printerAddrId2
        printerAddrId3
        printerAddrId4
        optionProducts {
            productId
            productName
        }
        cutlery
        thumbnailSize
        inbound
        is_recommended
    }
}
`;



/*
商品情報を更新

■リクエストパラメータ
input ProductInput {
  storeId: Int!
  orderType: Int!
    delivery {
        deliveryId: Int
    }
  categoryId: Int
    productId: Int
  productCode: String
  productName: String
    productNameEn: String
  imageUrl: String
  description: String
    descriptionEn: String
  price: Int
  cost: Float
    updateProduct: Array {
        updateProductId: Int
        updateTimer: String
        price: Int
        cost: Float
    }
    countProduct: {
        countProductId: Int
        quantity: Int
    }
  printerAddrId1: Int
  printerAddrId2: Int
  printerAddrId3: Int
  printerAddrId4: Int
  releaseTimer: String
  optionProducts: {
        productId: Int
    }
}

■レスポンス
categoryId: Int         カテゴリーID
delivery {
    deliveryId: Int       デリバリーID（1:Uber  2:出前館  3:Wolt  4:menu  99:その他）
    deliveryName: String    デリバリー名称
}
productId: Int          商品ID
productCode: String     商品コード
productName: String     商品名
productNameEn: String   商品名（英）
imageUrl: String        商品画像URL
description: String     商品内容
descriptionEn: String   商品内容（英）
price: Int              価格
taxRate: Int            税率
cost: Float             原価
updateProduct: Array {
    updateProductId: Int
    updateTimer: String     改定設定日時
    price: Int              改定単価
    cost: Float             改定原価
}
countProduct: {
    countProductId: Int     カウント商品ID
    quantity: Int           カウント商品数量
}
printerAddrId1: Int     チビ券出力先1
printerAddrId2: Int     チビ券出力先2
printerAddrId3: Int     チビ券出力先3
printerAddrId4: Int     チビ券出力先4
releaseTimer: String    公開日時
optionProducts: {
    productId
    productName
}
*/
export const updateProduct = `mutation updateProduct( $input: ProductInput ) {
    updateProduct( input: $input ) {
        categoryId
        delivery {
            deliveryId
            deliveryName
        }
        productId
        productCode
        productName
        productNameEn
        productNameCn
        productNameKr
        imageUrl
        description
        descriptionEn
        descriptionCn
        descriptionKr
        price
        taxRate
        updateProduct {
            updateProductId
            updateTimer
            price
            cost
        }
        countProduct {
            countProductId
            quantity
        }
        printerAddrId1
        printerAddrId2
        printerAddrId3
        printerAddrId4
        releaseTimer
        optionProducts {
            productId
            productName
        }
        cutlery
        thumbnailSize
        inbound
        is_recommended
    }
}
`;


// ============================================================================
// 全店舗共通商品（storeId = 9999）用
// createProduct / getProduct / updateProduct に配信対象の項目を追加したもの。
// 店舗別の既存画面に影響を与えないよう、専用の定数として定義している。
//
// delivery_target: Int          1: 配信対象全店  2: 店舗で指定  3: 地域で指定
// delivery_target_shops: String 店舗で指定　※店舗IDの配列テキスト
// delivery_target_region: String 地域で指定　※都道府県コードの配列テキスト
// ============================================================================
export const createMstProduct = `mutation createMstProduct( $input: ProductInput ) {
    createMstProduct( input: $input ) {
        storeId
        orderType
        categoryId
        delivery {
            deliveryId
            deliveryName
        }
        productId
        productCode
        productName
        productNameEn
        productNameCn
        productNameKr
        imageUrl
        description
        descriptionEn
        descriptionCn
        descriptionKr
        price
        taxRate
        releaseTimer
        updateProduct {
            updateProductId
            updateTimer
            price
            cost
        }
        countProduct {
            countProductId
            quantity
        }
        printerAddrId1
        printerAddrId2
        printerAddrId3
        printerAddrId4
        optionProducts {
            productId
            productName
        }
        cutlery
        thumbnailSize
        inbound
        is_recommended
    }
}
`;


export const getProductAll = `query getProduct( $productId: Int ) {
    getProduct( productId: $productId ) {
        categoryId
        delivery {
            deliveryId
            deliveryName
        }
        productId
        productCode
        menuCategory {
          menuCategoryId
          masterProductId
        }
        productName
        productNameEn
        productNameCn
        productNameKr
        imageUrl
        description
        descriptionEn
        descriptionCn
        descriptionKr
        price
        taxRate
        cost
        releaseTimer
        updateProduct {
            updateProductId
            updateTimer
            price
            cost
        }
        countProduct {
            countProductId
            quantity
        }
        printerAddrId1
        printerAddrId2
        printerAddrId3
        printerAddrId4
        optionProducts {
            productId
            productName
        }
        cutlery
        thumbnailSize
        inbound
        is_recommended
    }
}
`;


export const updateMstProduct = `mutation updateMstProduct( $input: ProductInput ) {
    updateMstProduct( input: $input ) {
        categoryId
        delivery {
            deliveryId
            deliveryName
        }
        productId
        productCode
        productName
        productNameEn
        productNameCn
        productNameKr
        imageUrl
        description
        descriptionEn
        descriptionCn
        descriptionKr
        price
        taxRate
        updateProduct {
            updateProductId
            updateTimer
            price
            cost
        }
        countProduct {
            countProductId
            quantity
        }
        printerAddrId1
        printerAddrId2
        printerAddrId3
        printerAddrId4
        releaseTimer
        optionProducts {
            productId
            productName
        }
        cutlery
        thumbnailSize
        inbound
        is_recommended
    }
}
`;


/*
アプリ営業時間設定を取得
■リクエストパラメータ
storeId     店舗ID

■レスポンス
appSalesTimeId: Int             アプリ営業時間設定ID
storeId: Int                    店舗ID            
monEarlyMorningTime: String     【月曜】テイクアウト早朝受付時間
monStartTime: String            【月曜】通常営業時間：開始
monEndTime: String              【月曜】通常営業時間：終了
monLunchBreakStartTime          【月曜】閉店タイム
monLunchBreakEndTime            【月曜】閉店タイム
monHoliday: Int                 【月曜】定休日
tueEarlyMorningTime: String     【火曜】テイクアウト早朝受付時間
tueStartTime: String            【火曜】通常営業時間：開始
tueEndTime: String              【火曜】通常営業時間：終了
tueLunchBreakStartTime          【火曜】閉店タイム
tueLunchBreakEndTime            【火曜】閉店タイム
tueHoliday: Int                 【火曜】定休日
wedEarlyMorningTime: String     【水曜】テイクアウト早朝受付時間
wedStartTime: String            【水曜】通常営業時間：開始
wedEndTime: String              【水曜】通常営業時間：終了
wedLunchBreakStartTime          【水曜】閉店タイム
wedLunchBreakEndTime            【水曜】閉店タイム
wedHoliday: Int                 【水曜】定休日
thuEarlyMorningTime: String     【木曜】テイクアウト早朝受付時間
thuStartTime: String            【木曜】通常営業時間：開始
thuEndTime: String              【木曜】通常営業時間：終了
thuLunchBreakStartTime          【木曜】閉店タイム
thuLunchBreakEndTime            【木曜】閉店タイム
thuHoliday: Int                 【木曜】定休日
friEarlyMorningTime: String     【金曜】テイクアウト早朝受付時間
friStartTime: String            【金曜】通常営業時間：開始
friEndTime: String              【金曜】通常営業時間：終了
friLunchBreakStartTime          【金曜】閉店タイム
friLunchBreakEndTime            【金曜】閉店タイム
friHoliday: Int                 【金曜】定休日
satEarlyMorningTime: String     【土曜】テイクアウト早朝受付時間
satStartTime: String            【土曜】通常営業時間：開始
satEndTime: String              【土曜】通常営業時間：終了
satLunchBreakStartTime          【土曜】閉店タイム
satLunchBreakEndTime            【土曜】閉店タイム
satHoliday: Int                 【土曜】定休日
sunEarlyMorningTime: String     【日曜】テイクアウト早朝受付時間
sunStartTime: String            【日曜】通常営業時間：開始
sunEndTime: String              【日曜】通常営業時間：終了
sunLunchBreakStartTime          【日曜】閉店タイム
sunLunchBreakEndTime            【日曜】閉店タイム
sunHoliday: Int                 【日曜】定休日
holiday: String                 臨時休業日
receptionStartHour: Int         テイクアウト受取余白時間　開始（時）
receptionStartMin: Int          テイクアウト受取余白時間　開始（分）
receptionEndHour: Int           テイクアウト受取余白時間　終了（時）
receptionEndMin: Int            テイクアウト受取余白時間　終了（分）
breakTime {
    appBreakTimeId          閉店タイムID ※ここで取得したIDを更新時のリクエストパラメータに使用してください
    startTime               閉店タイム（開始）
    endTime                 閉店タイム（終了）
    dayOfWeek               曜日（1：日曜　2：月曜　3：火曜　4：水曜　5：木曜　6：金曜　7：土曜）  
}
*/
export const getAppSalesTime = `query getAppSalesTime20230813( $storeId: Int ) {
    getAppSalesTime20230813( storeId: $storeId ) {
        appSalesTimeId
        storeId
        monEarlyMorningTime
        monStartTime
        monEndTime
        monLunchBreakStartTime
        monLunchBreakEndTime
        monHoliday
        tueEarlyMorningTime
        tueStartTime
        tueEndTime
        tueLunchBreakStartTime
        tueLunchBreakEndTime
        tueHoliday
        wedEarlyMorningTime
        wedStartTime
        wedEndTime
        wedLunchBreakStartTime
        wedLunchBreakEndTime
        wedHoliday
        thuEarlyMorningTime
        thuStartTime
        thuEndTime
        thuLunchBreakStartTime
        thuLunchBreakEndTime
        thuHoliday
        friEarlyMorningTime
        friStartTime
        friEndTime
        friLunchBreakStartTime
        friLunchBreakEndTime
        friHoliday
        satEarlyMorningTime
        satStartTime
        satEndTime
        satLunchBreakStartTime
        satLunchBreakEndTime
        satHoliday
        sunEarlyMorningTime
        sunStartTime
        sunEndTime
        sunLunchBreakStartTime
        sunLunchBreakEndTime
        sunHoliday
        holiday
        receptionStartHour
        receptionStartMin
        receptionEndHour
        receptionEndMin
        breakTime {
            appBreakTimeId
            startTime
            endTime
            dayOfWeek
            
        }
    }
}
`;



/*
アプリ営業時間設定を新規作成・更新
■リクエストパラメータ
appSalesTimeId: Int             アプリ営業時間設定ID
storeId: Int                    店舗ID            
monEarlyMorningTime: String     【月曜】テイクアウト早朝受付時間
monStartTime: String            【月曜】通常営業時間：開始
monEndTime: String              【月曜】通常営業時間：終了
monLunchBreakStartTime          【月曜】閉店タイム
monLunchBreakEndTime            【月曜】閉店タイム
monHoliday: Int                 【月曜】定休日
tueEarlyMorningTime: String     【火曜】テイクアウト早朝受付時間
tueStartTime: String            【火曜】通常営業時間：開始
tueEndTime: String              【火曜】通常営業時間：終了
tueLunchBreakStartTime          【火曜】閉店タイム
tueLunchBreakEndTime            【火曜】閉店タイム
tueHoliday: Int                 【火曜】定休日
wedEarlyMorningTime: String     【水曜】テイクアウト早朝受付時間
wedStartTime: String            【水曜】通常営業時間：開始
wedEndTime: String              【水曜】通常営業時間：終了
wedLunchBreakStartTime          【水曜】閉店タイム
wedLunchBreakEndTime            【水曜】閉店タイム
wedHoliday: Int                 【水曜】定休日
thuEarlyMorningTime: String     【木曜】テイクアウト早朝受付時間
thuStartTime: String            【木曜】通常営業時間：開始
thuEndTime: String              【木曜】通常営業時間：終了
thuLunchBreakStartTime          【木曜】閉店タイム
thuLunchBreakEndTime            【木曜】閉店タイム
thuHoliday: Int                 【木曜】定休日
friEarlyMorningTime: String     【金曜】テイクアウト早朝受付時間
friStartTime: String            【金曜】通常営業時間：開始
friEndTime: String              【金曜】通常営業時間：終了
friLunchBreakStartTime          【金曜】閉店タイム
friLunchBreakEndTime            【金曜】閉店タイム
friHoliday: Int                 【金曜】定休日
satEarlyMorningTime: String     【土曜】テイクアウト早朝受付時間
satStartTime: String            【土曜】通常営業時間：開始
satEndTime: String              【土曜】通常営業時間：終了
satLunchBreakStartTime          【土曜】閉店タイム
satLunchBreakEndTime            【土曜】閉店タイム
satHoliday: Int                 【土曜】定休日
sunEarlyMorningTime: String     【日曜】テイクアウト早朝受付時間
sunStartTime: String            【日曜】通常営業時間：開始
sunEndTime: String              【日曜】通常営業時間：終了
sunLunchBreakStartTime          【日曜】閉店タイム
sunLunchBreakEndTime            【日曜】閉店タイム
sunHoliday: Int                 【日曜】定休日
receptionStartHour: Int         テイクアウト受取余白時間　開始（時）
receptionStartMin: Int          テイクアウト受取余白時間　開始（分）
receptionEndHour: Int           テイクアウト受取余白時間　終了（時）
receptionEndMin: Int            テイクアウト受取余白時間　終了（分）
breakTime {
    appBreakTimeId          閉店タイムID ※ここで取得したIDを更新時のリクエストパラメータに使用してください　新規登録は値をnullとしてください
    startTime               閉店タイム（開始）
    endTime                 閉店タイム（終了）
    dayOfWeek               曜日（1：日曜　2：月曜　3：火曜　4：水曜　5：木曜　6：金曜　7：土曜）  
}

■レスポンス
result      更新完了レスポンス
*/
export const updateAppSalesTime = `mutation updateAppSalesTime20230813( $input: AppSalesTimeInput ) {
    updateAppSalesTime20230813( input: $input ) {
        result
    }
}
`;





/*
カウント商品を登録

■リクエストパラメータ
input CountProductInput {
    storeId             店舗ID
    countProductName    カウント商品名
}


■レスポンス
storeId             店舗ID
countProductId      カウント商品ID
countProductName    カウント商品名
*/
export const createCountProduct = `mutation createCountProduct( $input: [CountProductInput] ) {
    createCountProduct( input: $input ) {
        storeId
        countProductId
        countProductName
    }
}
`;

/*
インボイス登録番号を登録・更新

■リクエストパラメータ
input DeveloperAccountInput {
    developerUuid     ユーザー認証用UUID
    invoice         インボイス登録番号
}

■レスポンス
developerId     アカウントID
developerName   アカウント名
invoice         インボイス登録番号
*/
export const updateDeveloperInvoice = `mutation updateDeveloperInvoice( $input: DeveloperAccountInput ) {
    updateDeveloperInvoice( input: $input ) {
        developerId
        developerName
        invoice
    }
}
`;


/*
カウント商品出数一覧を取得

■リクエストパラメータ
storeId: Int            店舗ID
countProductId: Int     カウント商品ID
fromDate: String        検索開始日付
toDate: String          検索終了日付

■レスポンス
countProducts {
    countProductId      カウント商品ID
    countProductName    カウント商品名
}
daily {     // 日別
    label   日付
    number  件数
    output  出数
}
timezone {
    label   時間帯
    number  件数
    output  出数
}
*/
export const getCountProductOverview = `query getCountProductOverview( $storeId: Int, $countProductId: Int, $fromDate: String, $toDate: String ) {
    getCountProductOverview( storeId: $storeId, countProductId: $countProductId, fromDate: $fromDate, toDate: $toDate ) {
        countProducts {
            countProductId
            countProductName
        }
        daily {
            label
            number
            output
        }
        timezone {
            label
            number
            output
        }
    }
}
`;


/*
カウント商品出数・商品別内訳を取得

■リクエストパラメータ
storeId: Int            店舗ID
countProductId: Int     カウント商品ID
fromDate: String        検索開始日付
toDate: String          検索終了日付

■レスポンス
countProductName    カウント商品名
counts {     // 商品別
    label   商品名
    number  件数
    output  出数
}

*/
export const getCountProductDetail = `query getCountProductDetail( $storeId: Int, $countProductId: Int, $fromDate: String, $toDate: String ) {
    getCountProductDetail( storeId: $storeId, countProductId: $countProductId, fromDate: $fromDate, toDate: $toDate ) {
        countProductName
        counts {
            label
            number
            output
        }
    }
}
`;


/*
SalesView売上表示設定を読み込み

■リクエストパラメータ
developerUuid: String   ユーザー認証用UUID

■レスポンス
value: Int      SalesView売上表示設定（0 : 値引前表示　1 : 値引後表示）
*/
export const getSalesViewSaleMode = `query getSalesViewSaleMode( $developerUuid: String ) {
    getSalesViewSaleMode( developerUuid: $developerUuid ) {
        value
    }
}
`;


/*
SalesView売上表示設定を更新

■リクエストパラメータ
input SalesViewSaleModeInput {
    developerUuid: String   ユーザー認証用UUID
    value: Int      SalesView売上表示設定（0 : 値引前表示　1 : 値引後表示）
}

■レスポンス
result      更新完了レスポンス
*/
export const updateSalesViewSaleMode = `mutation updateSalesViewSaleMode( $input: SalesViewSaleModeInput ) {
    updateSalesViewSaleMode( input: $input ) {
        result
    }
}
`;

/*
■プッシュ通知一覧を取得
【リクエストパラメータ】
shop_id: Int	店舗ID

【レスポンス】
id: Int			プッシュ通知ID
shop_id: Int		店舗ID
title: String		プッシュ通知タイトル
description: String	プッシュ通知本文
release_timer: String	配信日時（YYYY-MM-DD HH:mm:ss）
send_flg: Int		配信済みフラグ（0: 未配信　1:配信済み）
created_at: String	作成日時
updated_at: String	更新日時

getPushNotifications(shop_id: Int) {
  id: Int
  shop_id: Int
  title: String
  description: String
  release_timer: String
  send_flg: Int
  created_at: String
  updated_at: String
}
*/
export const getPushNotifications = `query getPushNotifications( $shop_id: Int, $site_type: String ) {
    getPushNotifications( shop_id: $shop_id, site_type: $site_type ) {
      id
      site_type
      shop_id
      title
      description
      release_timer
      send_flg
      created_at
      updated_at
      delivery_target
      delivery_target_age
      delivery_target_gender
      delivery_target_region
      delivery_target_shops
    }
}
`;

/*
■プッシュ通知を登録
【リクエストパラメータ】
shop_id: Int		店舗ID
title: String		プッシュ通知タイトル
description: String	プッシュ通知本文
release_timer: String	配信日時（YYYY-MM-DD HH:mm:ss）

【レスポンス】
id: Int			プッシュ通知ID
shop_id: Int		店舗ID
title: String		プッシュ通知タイトル
description: String	プッシュ通知本文
release_timer: String	配信日時（YYYY-MM-DD HH:mm:ss）
send_flg: Int		配信済みフラグ（0: 未配信　1:配信済み）
created_at: String	作成日時
updated_at: String	更新日時

addPushNotification(input: {
  shop_id: Int, 
  title: String, 
  description: String, 
  release_timer: String
}) {
  id: Int
  shop_id: Int
  title: String
  description: String
  release_timer: String
  send_flg: Int
  created_at: String
  updated_at: String
}
*/
export const addPushNotification = `mutation addPushNotification( $input: PushNotificationInput ) {
    addPushNotification( input: $input ) {
      id
      site_type
      shop_id
      title
      description
      release_timer
      send_flg
      created_at
      updated_at
      delivery_target
      delivery_target_age
      delivery_target_gender
      delivery_target_region
      delivery_target_shops
    }
}
`;

/*
■プッシュ通知内容を更新
【リクエストパラメータ】
id: Int			プッシュ通知ID
title: String		プッシュ通知タイトル
description: String	プッシュ通知本文
release_timer: String	配信日時（YYYY-MM-DD HH:mm:ss）

【レスポンス】
id: Int			プッシュ通知ID
shop_id: Int		店舗ID
title: String		プッシュ通知タイトル
description: String	プッシュ通知本文
release_timer: String	配信日時（YYYY-MM-DD HH:mm:ss）
send_flg: Int		配信済みフラグ（0: 未配信　1:配信済み）
created_at: String	作成日時
updated_at: String	更新日時

updatePushNotification(input: {
  id: Int
  title: String
  description: String
  release_timer: String
}) {
  id: Int
  shop_id: Int
  title: String
  description: String
  release_timer: String
  send_flg: Int
  created_at: String
  updated_at: String
}
*/
export const updatePushNotification = `mutation updatePushNotification( $input: PushNotificationInput ) {
    updatePushNotification( input: $input ) {
      id
      site_type
      shop_id
      title
      description
      release_timer
      send_flg
      created_at
      updated_at
      delivery_target
      delivery_target_age
      delivery_target_gender
      delivery_target_region
      delivery_target_shops
    }
}
`;

/*
■プッシュ通知内容を削除
【リクエストパラメータ】
id: Int			プッシュ通知ID

【レスポンス】
result: Boolean		削除完了フラグ

deletePushNotification(id: Int) {
  result: Boolean
}
*/
export const deletePushNotification = `mutation deletePushNotification( $id: Int ) {
    deletePushNotification( id: $id ) {
	    result
    }
}
`;

/*
■クーポン一覧を取得
【リクエストパラメータ】
shop_id: Int		店舗ID

【レスポンス】
id: Int			クーポンID
shop_id: Int		店舗ID
target: Int		対象(1:アルバイト / 2:社員 / 3:副店長 / 4:店長 / 5:カリスマ店長)
target_type: Int	対象種別(1:対象以上 / 2:対象のみ)
coupon_name: String	クーポン名
image_url: String	キャンペーン画像
term_type: Int		期間種別(1:〇〇〇〇年〇月〇日～〇〇〇〇年〇月〇日まで / 2:指定なし)
start_date: String	期間開始日（YYYY-MM-DD）
end_date: String	期間終了日（YYYY-MM-DD）
use_range: Int		使用範囲(1:ホーム店舗のみ / 2:アプリ導入全店舗利用可能)
usage: Int		使用度(1:一度限り / 2:何度でも使用可能)
store_cooperation: Int	店舗連携(1:店舗で利用可能 / 2:アプリでのテイクアウトのみ)
coupon_number: String	クーポン番号
product_id: Int		商品ID
discount_type: Int	割引・値引(1:指定商品〇〇%割引 / 2:指定商品〇〇円値引)
discount_rate: Int	割引・値引（％）
discount_price: Int	割引・値引（円）
release_timer: String	公開日時（YYYY-MM-DD HH:mm:ss）
created_at: String	作成日時
updated_at: String	更新日時

getCoupons(shop_id: Int) {
  id: Int
  shop_id: Int
  target: Int
  target_type: Int
  coupon_name: String
  image_url: String
  term_type: Int
  start_date: String
  end_date: String
  use_range: Int
  usage: Int
  store_cooperation: Int
  coupon_number: String
  product_id: Int
  discount_type: Int
  discount_rate: Int
  discount_price: Int
  release_timer: String
  created_at: String
  updated_at: String
}
*/
export const getCoupons = `query getCoupons( $shop_id: Int ) {
  getCoupons( shop_id: $shop_id ) {
    id
    shop_id
    target
    target_type
    coupon_name
    image_url
    term_type
    start_date
    end_date
    use_range
    usage
    store_cooperation
    coupon_number
    product_id
    discount_type
    discount_rate
    discount_price
    manualCheckout
    release_timer
    created_at
    updated_at
    delivery_target
    delivery_target_age
    delivery_target_gender
    delivery_target_region
    delivery_target_shops
  }
}
`;

/*
■クーポンを登録
【リクエストパラメータ】
shop_id: Int		店舗ID
target: Int		対象(1:アルバイト / 2:社員 / 3:副店長 / 4:店長 / 5:カリスマ店長)
target_type: Int	対象種別(1:対象以上 / 2:対象のみ)
coupon_name: String	クーポン名
image_url: String	キャンペーン画像
term_type: Int		期間種別(1:〇〇〇〇年〇月〇日～〇〇〇〇年〇月〇日まで / 2:指定なし)
start_date: String	期間開始日（YYYY-MM-DD）
end_date: String	期間終了日（YYYY-MM-DD）
use_range: Int		使用範囲(1:ホーム店舗のみ / 2:アプリ導入全店舗利用可能)
usage: Int		使用度(1:一度限り / 2:何度でも使用可能)
store_cooperation: Int	店舗連携(1:店舗で利用可能 / 2:アプリでのテイクアウトのみ)
coupon_number: String	クーポン番号
product_id: Int		商品ID
discount_type: Int	割引・値引(1:指定商品〇〇%割引 / 2:指定商品〇〇円値引)
discount_rate: Int	割引・値引（％）
discount_price: Int	割引・値引（円）
release_timer: String	公開日時（YYYY-MM-DD HH:mm:ss）

【レスポンス】
id: Int			クーポンID
shop_id: Int		店舗ID
target: Int		対象(1:アルバイト / 2:社員 / 3:副店長 / 4:店長 / 5:カリスマ店長)
target_type: Int	対象種別(1:対象以上 / 2:対象のみ)
coupon_name: String	クーポン名
image_url: String	キャンペーン画像
term_type: Int		期間種別(1:〇〇〇〇年〇月〇日～〇〇〇〇年〇月〇日まで / 2:指定なし)
start_date: String	期間開始日（YYYY-MM-DD）
end_date: String	期間終了日（YYYY-MM-DD）
use_range: Int		使用範囲(1:ホーム店舗のみ / 2:アプリ導入全店舗利用可能)
usage: Int		使用度(1:一度限り / 2:何度でも使用可能)
store_cooperation: Int	店舗連携(1:店舗で利用可能 / 2:アプリでのテイクアウトのみ)
coupon_number: String	クーポン番号
product_id: Int		商品ID
discount_type: Int	割引・値引(1:指定商品〇〇%割引 / 2:指定商品〇〇円値引 / 3:合計金額から〇〇%割引 / 4:合計金額から〇〇円値引)
discount_rate: Int	割引・値引（％）
discount_price: Int	割引・値引（円）
release_timer: String	公開日時（YYYY-MM-DD HH:mm:ss）
created_at: String	作成日時
updated_at: String	更新日時

addCoupon(input: {
  shop_id: Int
  target: Int
  target_type: Int
  coupon_name: String
  image_url: String
  term_type: Int
  start_date: String
  end_date: String
  use_range: Int
  usage: Int
  store_cooperation: Int
  coupon_number: String
  product_id: Int
  discount_type: Int
  discount_rate: Int
  discount_price: Int
  release_timer: String
  }) {
  id: Int
  shop_id: Int
  target: Int
  target_type: Int
  coupon_name: String
  image_url: String
  term_type: Int
  start_date: String
  end_date: String
  use_range: Int
  usage: Int
  store_cooperation: Int
  coupon_number: String
  product_id: Int
  discount_type: Int
  discount_rate: Int
  discount_price: Int
  release_timer: String
  created_at: String
  updated_at: String
  }
}
*/
export const addCoupon = `mutation addCoupon( $input: CouponInput ) {
  addCoupon( input: $input ) {
    id
    shop_id
    target
    target_type
    coupon_name
    image_url
    term_type
    start_date
    end_date
    use_range
    usage
    store_cooperation
    coupon_number
    product_id
    discount_type
    discount_rate
    discount_price
    manualCheckout
    release_timer
    created_at
    updated_at
    delivery_target
    delivery_target_age
    delivery_target_gender
    delivery_target_region
    delivery_target_shops
  }
}
`;

/*
■クーポンを更新
【リクエストパラメータ】
id: Int			クーポンID
shop_id: Int		店舗ID
target: Int		対象(1:アルバイト / 2:社員 / 3:副店長 / 4:店長 / 5:カリスマ店長)
target_type: Int	対象種別(1:対象以上 / 2:対象のみ)
coupon_name: String	クーポン名
image_url: String	キャンペーン画像
term_type: Int		期間種別(1:〇〇〇〇年〇月〇日～〇〇〇〇年〇月〇日まで / 2:指定なし)
start_date: String	期間開始日（YYYY-MM-DD）
end_date: String	期間終了日（YYYY-MM-DD）
use_range: Int		使用範囲(1:ホーム店舗のみ / 2:アプリ導入全店舗利用可能)
usage: Int		使用度(1:一度限り / 2:何度でも使用可能)
store_cooperation: Int	店舗連携(1:店舗で利用可能 / 2:アプリでのテイクアウトのみ)
coupon_number: String	クーポン番号
product_id: Int		商品ID
discount_type: Int	割引・値引(1:指定商品〇〇%割引 / 2:指定商品〇〇円値引 / 3:合計金額から〇〇%割引 / 4:合計金額から〇〇円値引)
discount_rate: Int	割引・値引（％）
discount_price: Int	割引・値引（円）
release_timer: String	公開日時（YYYY-MM-DD HH:mm:ss）

【レスポンス】
id: Int			クーポンID
shop_id: Int		店舗ID
target: Int		対象(1:アルバイト / 2:社員 / 3:副店長 / 4:店長 / 5:カリスマ店長)
target_type: Int	対象種別(1:対象以上 / 2:対象のみ)
coupon_name: String	クーポン名
image_url: String	キャンペーン画像
term_type: Int		期間種別(1:〇〇〇〇年〇月〇日～〇〇〇〇年〇月〇日まで / 2:指定なし)
start_date: String	期間開始日（YYYY-MM-DD）
end_date: String	期間終了日（YYYY-MM-DD）
use_range: Int		使用範囲(1:ホーム店舗のみ / 2:アプリ導入全店舗利用可能)
usage: Int		使用度(1:一度限り / 2:何度でも使用可能)
store_cooperation: Int	店舗連携(1:店舗で利用可能 / 2:アプリでのテイクアウトのみ)
coupon_number: String	クーポン番号
product_id: Int		商品ID
discount_type: Int	割引・値引(1:指定商品〇〇%割引 / 2:指定商品〇〇円値引 / 3:合計金額から〇〇%割引 / 4:合計金額から〇〇円値引)
discount_rate: Int	割引・値引（％）
discount_price: Int	割引・値引（円）
release_timer: String	公開日時（YYYY-MM-DD HH:mm:ss）
created_at: String	作成日時
updated_at: String	更新日時

updateCoupon( input: {
  id: Int
  shop_id: Int
  target: Int
  target_type: Int
  coupon_name: String
  image_url: String
  term_type: Int
  start_date: String
  end_date: String
  use_range: Int
  usage: Int
  store_cooperation: Int
  coupon_number: String
  product_id: Int
  discount_type: Int
  discount_rate: Int
  discount_price: Int
  release_timer: String
} ) {
  id: Int
  shop_id: Int
  target: Int
  target_type: Int
  coupon_name: String
  image_url: String
  term_type: Int
  start_date: String
  end_date: String
  use_range: Int
  usage: Int
  store_cooperation: Int
  coupon_number: String
  product_id: Int
  discount_type: Int
  discount_rate: Int
  discount_price: Int
  release_timer: String
  created_at: String
  updated_at: String
}
*/
export const updateCoupon = `mutation updateCoupon( $input: CouponInput ) {
  updateCoupon( input: $input ) {
    id
    shop_id
    target
    target_type
    coupon_name
    image_url
    term_type
    start_date
    end_date
    use_range
    usage
    store_cooperation
    coupon_number
    product_id
    discount_type
    discount_rate
    discount_price
    manualCheckout
    release_timer
    created_at
    updated_at
    delivery_target
    delivery_target_age
    delivery_target_gender
    delivery_target_region
    delivery_target_shops
  }
}
`;

/*
■クーポンを削除
【リクエストパラメータ】
id: Int			クーポンID

【レスポンス】
result: Boolean		削除完了フラ

deleteCoupon(id: Int) {
  result: Boolean
}
*/
export const deleteCoupon = `mutation deleteCoupon( $id: Int ) {
  deleteCoupon( id: $id ) {
    result
  }
}
`;

/*
■テーブルオーダー・広告画像・映像一覧を取得
【リクエストパラメータ】
shop_id: Int			店舗ID

【レスポンス】
id: Int				TTO ID
shop_id: Int			店舗ID
category: Int			カテゴリーID（1: 画像　2:YouTube　3:非表示）
source: String			画像のURLかYouTubeのID
targetProductCode: String	リンク対象商品
displayTime: Int		表示時間（秒）
displaySequence: Int		表示順
created_at: String		作成日時
updated_at: String		更新日時

getTtoMedia(shop_id: Int) {
  id: Int
  shop_id: Int
  category: Int
  source: String
  targetProductCode: String
  displayTime: Int
  displaySequence: Int
  created_at: String
  updated_at: String
}
*/
export const getTtoMedia = `query getTtoMedia( $shop_id: Int ) {
  getTtoMedia( shop_id: $shop_id ) {
    id
    shop_id
    category
    source
    targetProductCode
    displayTime
    displaySequence
    created_at
    updated_at
    delivery_target
    delivery_target_age
    delivery_target_gender
    delivery_target_region
    delivery_target_shops
  }
}
`;

/*
■テーブルオーダー・広告画像・映像を登録
【リクエストパラメータ】
shop_id: Int			店舗ID
category: Int			カテゴリーID（1: 画像　2:YouTube　3:非表示）
source: String			画像のURLかYouTubeのID
targetProductCode: String	リンク対象商品
displayTime: Int		表示時間（秒）
displaySequence: Int		表示順

【レスポンス】
id: Int				TTO ID
shop_id: Int			店舗ID
category: Int			カテゴリーID（1: 画像　2:YouTube　3:非表示）
source: String			画像のURLかYouTubeのID
targetProductCode: String	リンク対象商品
displayTime: Int		表示時間（秒）
displaySequence: Int		表示順
created_at: String		作成日時
updated_at: String		更新日時

addTtoMedia(input: {
  shop_id: Int
  category: Int
  source: String
  targetProductCode: String
  displayTime: Int
  displaySequence: Int
}) {
  id: Int
  shop_id: Int
  category: Int
  source: String
  targetProductCode: String
  displayTime: Int
  displaySequence: Int
  created_at: String
  updated_at: String
}
*/
export const addTtoMedia = `mutation addTtoMedia( $input: TtoMediaInput ) {
  addTtoMedia( input: $input ) {
    id
    shop_id
    category
    source
    targetProductCode
    displayTime
    displaySequence
    created_at
    updated_at
    delivery_target
    delivery_target_age
    delivery_target_gender
    delivery_target_region
    delivery_target_shops
  }
}
`;

/*
■テーブルオーダー・広告画像・映像を更新
【リクエストパラメータ】
id: Int				TTO ID
shop_id: Int			店舗ID
category: Int			カテゴリーID（1: 画像　2:YouTube　3:非表示）
source: String			画像のURLかYouTubeのID
targetProductCode: String	リンク対象商品
displayTime: Int		表示時間（秒）
displaySequence: Int		表示順

【レスポンス】
id: Int				プッシュ通知ID
shop_id: Int			店舗ID
category: Int			カテゴリーID（1: 画像　2:YouTube　3:非表示）
source: String			画像のURLかYouTubeのID
targetProductCode: String	リンク対象商品
displayTime: Int		表示時間（秒）
displaySequence: Int		表示順
created_at: String		作成日時
updated_at: String		更新日時

updateTtoMedia(input: {
  id: Int
  shop_id: Int
  category: Int
  source: String
  targetProductCode: String
  displayTime: Int
  displaySequence: Int
}) {
  id: Int
  shop_id: Int
  category: Int
  source: String
  targetProductCode: String
  displayTime: Int
  displaySequence: Int
  created_at: String
  updated_at: String
}
*/
export const updateTtoMedia = `mutation updateTtoMedia( $input: TtoMediaInput ) {
  updateTtoMedia( input: $input ) {
    id
    shop_id
    category
    source
    targetProductCode
    displayTime
    displaySequence
    created_at
    updated_at
    delivery_target
    delivery_target_age
    delivery_target_gender
    delivery_target_region
    delivery_target_shops
  }
}
`;

/*
■テーブルオーダー・広告画像・映像を削除
【リクエストパラメータ】
id: Int				TTO ID

【レスポンス】
result: Boolean		削除完了フラ

deleteTtoMedia(id: Int) {
  result: Boolean
}
*/
export const deleteTtoMedia = `mutation deleteTtoMedia( $id: Int ) {
  deleteTtoMedia( id: $id ) {
    result
  }
}
`;


export const getProductMenuCategoryList = `query getProductMenuCategoryList( $shop_id: Int ) {
  getProductMenuCategoryList( shop_id: $shop_id ) {
    id
    shop_id
    menuCategoryId
    menuCategoryCode
    menuCategoryName
    price
    cost
    startTime
    endTime
    timeLimit
    displaySequence
  }
}
`;

export const getProductMenuCategory = `query getProductMenuCategory( $id: Int ) {
  getProductMenuCategory( id: $id ) {
    id
    shop_id
    menuCategoryId
    menuCategoryCode
    menuCategoryName
    menuCategoryNameEn
    menuCategoryNameCn
    menuCategoryNameKr
    price
    cost
    startTime
    endTime
    timeLimit
    salesDayMonday
    salesDayTuesday
    salesDayWednesday
    salesDayThursday
    salesDayFriday
    salesDaySaturday
    salesDaySunday
    dayOfEveryMonth
    displaySequence
    masterProductId
  }
}
`;

export const getDailySumByStore = `query getDailySumByStore($shop_ids: [Int], $fromDate: String, $toDate: String) {
  getDailySumByStore(shop_ids: $shop_ids, fromDate: $fromDate, toDate: $toDate) {
    body {
      item {
        column
        value
        unit
        dsmColumnId
        fmtId
        label
      }
    }
  }
}
`;

/*
■ホーム画面動画URLを取得
【リクエストパラメータ】
shop_id: Int  店舗ID

【レスポンス】
shop_id: Int      店舗ID
video_url: String 動画URL
created_at: String
updated_at: String
*/
export const getHomeVideoUrl = `query getHomeVideoUrl( $shop_id: Int ) {
  getHomeVideoUrl( shop_id: $shop_id ) {
    shop_id
    video_url
    created_at
    updated_at
  }
}
`;

